import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  MixedGridGroup,
  QuantaFormik,
  QuantaForm,
  useResponsiveParams,
  useQuantaFormikContext,
  Text,
  QuantaInput,
  QuantaButton,
  InputGridGroup,
  QuantaDateInput,
  Grid,
  GridItem,
} from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faExclamation,
  faInfoCircle,
  faSearch,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
// import { updateMotorQuote } from '../../_graphql/state';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
import VehicleDataModal from './vehicle-data-modal';
import PreviousInsurance from './previous-insurance-claims/previous-insurance';
import PreviousClaims from './previous-insurance-claims/previous-claims';
import InsuredDeclaredForm from './insured-declared-form';
import IRFForm from './Irfform';
import Discounts from './discounts';
import CoversForm from './coverdata';
import { useQuery } from '@apollo/client';
import {
  VEHICLE_DETAILS,
  GET_TWO_WHEELER_POLICY_VAR_DETAILS,
  PRODUCT_TYPE_LIST,
  CAR_SECURE_BUSINESS_TYPE,
  DISCOUNT_DROPDOWN_DETAILS,
  CLAIM_DETAILS,
  PRODUCT_VARIANT,
  APPLICABLE_COVERS,
  GET_FIELDUSER_LIST,
  CHARACTER_LIMIT_LIST,
  AGE_LIMIT,
  DCA_AGE_LIMIT,
  DEP_AGE_LIMIT,
  TYRE_AGE_LIMIT,
  NCBPROTECT_AGE_LIMIT,
  GET_CREDIT_SCORE_DTLS,
  VEHICLE_AGE_LIMIT,
  TENYEAR_AGE_LIMIT,
  RTO_LIST_BRAND_LIST_YEAR_RANGE,
  MODEL_DETAILS,
  VARIANT_DETAILS,
  GET_RTO_DETAILS ,
  PREVIOUS_CLAIMS_DROPDOWN_DETAILS
  //SAEA BT17345
} from '../../queries';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';
//import useFetchQuery from './lib/graphql/useFetchCacheQuery';
import { useFetchQuery } from 'quanta-flows';
import VehicleDetails from './vehicle-details';
import { QuantaConfigContext } from 'quanta-flows';
import moment from 'moment';
export default function Vehicle({
  productCode,
  setproceedToCoverPage,
  lobCode,
  productName,
  lobName,
  quoteNumber,
  setParentAlerts,
  productCode1,
  setProductCode,
  modify,
  setLoadingStep,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  let repeat_for_mobile = 1;
  let repeat_for_desktop = 3;
  const { branding } = useContext(QuantaConfigContext);
  let repeat = useResponsiveParams({
    for_mobile: repeat_for_mobile,
    for_desktop: repeat_for_desktop,
  });
  const [initialValues, setInitialValues] = useState(null);
  const initLoadRef = useRef([]);
  const [loadingCovers, setLoadingCovers] = useState(false);
  const [errorCovers, setErrorCovers] = useState(null);
  const [coversInfo, setCoversInfo] = useState(null);
  const [initLoad, setInitLoad] = useState(true);
  const [fieldUserList, setFieldUserList] = useState([]);
  const [productloading, setproductloading] = useState('3121');

  const {
    loading: loadingMotorQuote1,
    error: errorMotorQuote1,
    data: dataMotorQuote,
    previousData: previousDataMotorQuote,
  } = useQuery(GET_TWO_WHEELER_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    skip: !initLoad,
    onCompleted: async (data) => {
      const { motorQuote, selectedIntermediary } = data;
      try {
        setErrorCovers(null);
        const applicableCoversQuery = fetchQuery({
          query: APPLICABLE_COVERS,
          fetchPolicy: data?.motorQuote?.quotationNo
            ? 'cache-first'
            : 'network-only',
          variables: {
            input: {
              productCode: '3121',
              productType: data?.motorQuote?.productType,
              intermediaryCode:
                data?.selectedIntermediary?.intermediaryCode,
              fuelType: data?.motorQuote?.fuelType,
            },
          },
        });
        const getFieldUserList = fetchQuery({
          query: GET_FIELDUSER_LIST,
          variables: {
            input: {
              intermediaryCode: (motorQuote?.intermediaryDetails?.code || selectedIntermediary?.intermediaryCode),
              officeId: (motorQuote?.intermediaryDetails?.location || selectedIntermediary?.branchOfficeCode)
            }
          }
        });
        setLoadingCovers(true);
        const { data: coversData } = await applicableCoversQuery;
        setCoversInfo(coversData);
        setInitialValues(data?.motorQuote);
        const { data: dataFieldUserList } = await getFieldUserList;
        setInitLoad(false);
        setFieldUserList(dataFieldUserList?.getFiledUserByIMID);
        setLoadingCovers(false);
      } catch (error) {
        setLoadingCovers(false);
        setErrorCovers(error?.message);
      }
    },
  });


  const { loading: loadingMotorQuote, error: errorMotorQuote } =
    useQuery(GET_TWO_WHEELER_POLICY_VAR_DETAILS, {
      fetchPolicy: 'cache-first',
      skip: new Set(initLoadRef?.current).size >= 3 ? true : false,
      onCompleted: (data) => {
        setInitialValues(data?.motorQuote);
        initLoadRef.current = [...initLoadRef.current, 1];
      },
    });
  const { loading: loadingDiscountData, data: discountData } =
    useQuery(DISCOUNT_DROPDOWN_DETAILS, {
      fetchPolicy: 'cache-first',
      variables: {
        productCode,
      },
      onCompleted: (data) => {
        initLoadRef.current = [...initLoadRef.current, 2];
      },
    });
    //SA BT17345
    const { loading: loadingVehicleAgeLimit, data: VehicleAgeLimit,refetch } =
    useQuery(VEHICLE_AGE_LIMIT, {
      fetchPolicy: 'cache-first',
      variables: {
        productCode1,
      },
      onCompleted: (data) => {
        initLoadRef.current = [...initLoadRef.current, 4];
      },
    });
  //EA BT17345
  const {
    loading: loadingProductType,
    error: errorProductType,
    data: productTypeData,
  } = useQuery(PRODUCT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      initLoadRef.current = [...initLoadRef.current, 3];
    },
  });
  const { loading: loadingProductVariant,
    error: errorProductVariant,
    data: productVariantTypeData, } = useQuery(PRODUCT_VARIANT, {
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          productCode: "All",
          domainType: 'Product Variant',
        },
      },
      onCompleted: (data) => {
      },
    });
  const {
    loading: loadingNameLimit,
    error: errorNameLimit,
    data: dataNameLimit,
    previousData: previousDataNameLimit
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
    skip: !initLoad
  });
  const { loading: loadingtenyearlimit,
    error: errortenyearlimit,
    data: tenyearlimitdata, } = useQuery(TENYEAR_AGE_LIMIT, {
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          productCode: 3121,
          domainType: 'TEN Age Limit',
        },
      },
      onCompleted: (data) => {
        
      },
    });
  const { loading: loadingagelimit,
    error: erroragelimit,
    data: agelimitdata, } = useQuery(AGE_LIMIT, {
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          productCode: 3121,
          domainType: 'Consumable Cover Age Limit',
        },
      },
      onCompleted: (data) => {
      },
    });
    const { loading: loadingDCAagelimit,
      error: errorDCAagelimit,
      data: DCAagelimitdata, } = useQuery(DCA_AGE_LIMIT, {
        fetchPolicy: 'cache-and-network',
        variables: {
          input: {
            productCode: 3121,
            domainType: 'DCACover Age Limit',
          },
        },
        onCompleted: (data) => {
        },
      });
      const { loading: loadingtyreagelimit,
        error: errortyreagelimit,
        data: tyrelimitdata, } = useQuery(TYRE_AGE_LIMIT, {
          fetchPolicy: 'cache-and-network',
          variables: {
            input: {
              productCode: 3121,
              domainType: 'TYRE Cover Age Limit',
            },
          },
          onCompleted: (data) => {
          },
        });
        const { loading: loadingNCBprotectlimit,
          error: errorNCBprotectlimit,
          data: NCBprotectlimitdata, } = useQuery(NCBPROTECT_AGE_LIMIT, {
            fetchPolicy: 'cache-and-network',
            variables: {
              input: {
                productCode: 3121,
                domainType: 'NCB Age Limit',
              },
            },
            onCompleted: (data) => {
              //console.log("123",data)
            },
          });
      const { loading: loadingDEPagelimit,
        error: errorDEPagelimit,
        data: DEPlimitdata, } = useQuery(DEP_AGE_LIMIT, {
          fetchPolicy: 'cache-and-network',
          variables: {
            input: {
              productCode: 3121,
              domainType: 'DEP Cover Age Limit',
            },
          },
          onCompleted: (data) => {
          },
        });

  let repeatForMobile = 1;
  let repeatForDesktop = 3;
  if (
    loadingProductType ||
    loadingMotorQuote ||
    loadingDiscountData ||
    loadingProductVariant ||
    loadingCovers ||
    loadingMotorQuote1 ||
    loadingNameLimit||
    loadingagelimit||
    loadingtyreagelimit||
    loadingDCAagelimit||
    loadingDEPagelimit||
    loadingNCBprotectlimit ||
    loadingVehicleAgeLimit||
    loadingtenyearlimit//SAEA BT17345

  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (errorProductType || errorMotorQuote) {
    return <Error error={errorProductType || errorMotorQuote} />;
  }
  const { lobProductList } = productTypeData;
  const { PRD_vehicleOwnedByList,
    PRD_IDProofTypeForCreditScoreList,
    PRD_VoluntaryDeductibleAmount, } = discountData;
  const{PRD_VehicleAgeLimit}=VehicleAgeLimit;//SAEA BT17345
  const productVariantList = productVariantTypeData?.getDomainData
  const { motorQuote, selectedIntermediary } = dataMotorQuote
    ? dataMotorQuote
    : previousDataMotorQuote;
  const { characterLimitList } = dataNameLimit ? dataNameLimit : previousDataNameLimit;
  const consumable_limit = agelimitdata?.getDomainData
  const tyre_limit=tyrelimitdata?.getDomainData
  const DEP_limit=DEPlimitdata?.getDomainData
  const NCB_limit = NCBprotectlimitdata?.getDomainData
  const DCA_limit = DCAagelimitdata?.getDomainData
  const TENYR_LIMIT = tenyearlimitdata?.getDomainData

  const validate = (values) => {
    const errors = {};
    let stateCode = /^([a-zA-Z]){2}?$/;
    let BHstateCode =/^([0-9]){2}?$/
    let distCode = /^([a-zA-Z0-9]){2}?$/;
    let BHdistCode = /^([a-zA-Z]){2}?$/;
    // let uniqueCode = /^([a-zA-Z]){2}?$/;
    // let uniqueCode = /^([a-zA-Z])?$/;
    let uniqueCode = /^[A-Za-z\s]*$/
    // let BHuniqueCode = /^([0-9]){3}?$/;
    let uniqueNumber = /^([0-9]){4}?$/;
    let BHuniqueNumber =/^([a-zA-Z])?$/; // /^([a-zA-Z]){2}?$/;
    if (!values?.productType) {
      errors.productType = '* Required';
    }
    if (values?.productVariant==='') {
      errors.productVariant = '* Required';
    }

    //if (moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) > 473353890000) {
    //  errors.productType =
     //   '* Vehicle age cannot be greater than 15 years';
    //}
    //SA BT17245
    let vehregno= `${values?.vehicleRegNo?.part1}${values?.vehicleRegNo?.part2}`;
    
    if(vehregno?.toLowerCase()==='ap39'&&!values?.rtoAuthorityCode?.includes('AP'))
      {
        errors.regNo = ' *For AP39 Registration Numbers, RTO must belong to Andhra Pradesh(AP) only';
      }
    if ((moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) > parseInt(PRD_VehicleAgeLimit?.code)) && productCode1?.toString()==='3176') {
      errors.productType =
        `* Vehicle age cannot be greater than ${PRD_VehicleAgeLimit?.value} years`;
    }
    else{
      if(productCode1?.toString()==='3121' || productCode1?.toString()==='3151'){
        if ((moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) > 473353890000)) {
          errors.productType =
            '* Vehicle age cannot be greater than 15 years';
        }
      }
    }
    //EA BT17245
        if (values.businessType === 'New Business') {
      if (moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) > 23760000000) {
        errors.productType =
          '* Vehicle age cannot be greater than 275 days for New Business Type';
      }
    }
    if (values.businessType === 'Used Car') {
      if (moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) < 23760000000) {
        errors.productType =
          '* Vehicle age cannot be less than 275 days for Used Car Type';
      }
    }
    if (productCode1?.toString() === '3151'
    && values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() === 'yes'
    //  && values?.policyCoverType!=='OD Only'
     ) {
    // if (!values?.TP_Policy_Tenure) {
    //   errors.TP_Policy_Tenure = '* Required';
    // }
    if (!values?.TP_Start_Date) {
      errors.TP_Start_Date = '* Required';
    }
      if (!values?.TP_End_Date) {
      errors.TP_End_Date = '* Required';
    }
  }
  if (values?.businessType?.toLowerCase() === 'new business'
  && values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() === 'yes'
  && values?.previousYearNCBSlab === '0' ) {
      errors.previousYearNCBSlab = '* NCB cannot be 0';
  }
  if (values.productType === 'Kotak Car Secure OD Only' 
   && values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() === 'no'){
       errors.PreviousPolicyforVehicleTaken = 'Previous Policy Details are mandatory for OD Only'
  }
    if (values.productType === 'ODOnly') {
      if (moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) < 31556926000) {
        errors.productType =
          '* Vehicle age should be greater than 1 Year for ODOnly';
      }
    }
    if (values.businessType === 'Roll Over') {
      if (values.productType === 'Kotak Car Secure (1+1)' || values.productType === 'Kotak Car Secure Liability Only –1 years' 
      // || values.productType === 'Kotak Car Secure OD Only' //Removed 
      ) {
        if (moment().diff(moment(values?.dateOfReg, 'DD/MM/YYYY')) < 78892315000) {
          errors.productType =
            '* Vehicle age should be greater than 2.5 Year for roll over';
        }
      }
    }
    if (values.businessType === 'Roll Over'&& values.productType === 'Kotak Car Secure OD Only') {
      if (moment(new Date(), 'DD/MM/YYYY').diff(
        moment(values?.dateOfReg, 'DD/MM/YYYY'), 'days') <  275
        ) {
        errors.productType =
          '* Vehicle age cannot be less than 275 days for OD';
      }
    }
    if (
        values?.businessType
        ?.toLowerCase()
        ?.trim()
        ?.search('roll over') !== -1
        ||
        values?.businessType
        ?.toLowerCase()
        ?.trim()
        ?.search('used car') !== -1
    ) {
      if (
        !values?.vehicleRegNo?.part1 ||
        !values?.vehicleRegNo?.part2 ||
        (!values?.vehicleRegNo?.part3 &&     
          values?.vehicleRegNo?.bhseries === true ) ||    // SADivya IM241121/23693 - 3RD block as non mandatory 
        !values?.vehicleRegNo?.part4
      ) {
        errors.regNo = '* Required';
      }
    }
    if (
      values?.vehicleRegNo?.part1 ||
      values?.vehicleRegNo?.part2 ||
      values?.vehicleRegNo?.part3 ||
      values?.vehicleRegNo?.part4
    ) {
      if (
        !values?.vehicleRegNo?.part1 &&
        values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.part3 &&
        values?.vehicleRegNo?.part4
      ) {
        errors.regNo = '* State Code is Required';
      }
      if (
       ( values?.vehicleRegNo?.part1 &&
        !stateCode.test(values?.vehicleRegNo?.part1))&& values?.vehicleRegNo?.bhseries!==true
      ) {
        errors.regNo = '* Enter valid State or Union Territory Code';
      }
      if (
        ( values?.vehicleRegNo?.part1 &&
         !BHstateCode.test(values?.vehicleRegNo?.part1))&& values?.vehicleRegNo?.bhseries===true
       ) {
         errors.regNo = '* Enter valid year of registration ';
       }
       const d = new Date();
       let year = d.getFullYear().toString().slice(-2);
       let BHyear = Number(year)
       if (
        ( values?.vehicleRegNo?.part1 <21 || values?.vehicleRegNo?.part1 > BHyear
         && values?.vehicleRegNo?.bhseries===true)
       ) {
         errors.regNo = '* Enter valid year of registration ';
       }
      if (
        !values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.part1 &&
        values?.vehicleRegNo?.part3 &&
        values?.vehicleRegNo?.part4&& values?.vehicleRegNo?.bhseries!==true
      ) {
        errors.regNo = '* District Sequential Number is Required';
      }
      if (values?.vehicleRegNo?.part2&& values?.vehicleRegNo?.bhseries!==true) {
        if (!distCode.test(values?.vehicleRegNo?.part2)) {
          errors.regNo = '* Enter valid District Sequential Number';
        }
      }
      if (values?.vehicleRegNo?.part2&& values?.vehicleRegNo?.bhseries===true) {
      
        if (values?.vehicleRegNo?.part2?.toString()?.toUpperCase()!=='BH') {
          errors.regNo = '* Enter valid Code for Bharat Series';
        }
      }
      // if (
      //   !values?.vehicleRegNo?.part3 &&
      //   values?.vehicleRegNo?.part1 &&
      //   values?.vehicleRegNo?.part2 &&
      //   values?.vehicleRegNo?.part4
      // ) {
      //   errors.regNo = '* Unique Code is Required';
      // }
      if (values?.vehicleRegNo?.part3) {
        if (!uniqueCode.test(values?.vehicleRegNo?.part3)&& values?.vehicleRegNo?.bhseries!==true) {
          errors.regNo = '* Unique Code cannot be alphanumeric';
      }
     
       }
      if (values?.vehicleRegNo?.part3&& values?.vehicleRegNo?.bhseries===true) {
        if (
          // (values?.vehicleRegNo?.part3?.length<=3)&&
          (!values?.vehicleRegNo?.part3?.match(/^[0-9]+$/))){
          errors.regNo = '*  Unique Number can be only Digits';
        }
        if (
          (values?.vehicleRegNo?.part3?.length<=2)){
          errors.regNo = '*  Unique Number cannot be less than 3 digit';
        }
      }
      if (
        !values?.vehicleRegNo?.part4 &&
        values?.vehicleRegNo?.part1 &&
        values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.part3
      ) {
        errors.regNo = '* Unique Number is Required';
      }
      if ((values?.vehicleRegNo?.part4)&& values?.vehicleRegNo?.bhseries!==true) {
        if (!uniqueNumber.test(values?.vehicleRegNo?.part4)) {
          errors.regNo = '* Unique Number can be only Digits';
        }
      }
      if ((values?.vehicleRegNo?.part4)&& values?.vehicleRegNo?.bhseries===true) {
        if (//!BHuniqueNumber.test(values?.vehicleRegNo?.part4)
          !values?.vehicleRegNo?.part4?.match(/^[a-zA-Z ]+$/)) {
          errors.regNo = '* Unique Number can be only Alphabets';
        }
      }
      if ( values?.vehicleRegNo?.bhseries !== true &&
        values?.vehicleRegNo?.part1 &&
        values?.vehicleRegNo?.part2 &&
        values?.vehicleRegNo?.part3 &&
        values?.vehicleRegNo?.part4 &&
        stateCode.test(values?.vehicleRegNo?.part1) &&
        distCode.test(values?.vehicleRegNo?.part2) &&
        uniqueCode.test(values?.vehicleRegNo?.part3) &&
        uniqueNumber.test(values?.vehicleRegNo?.part4) &&
        !values?.isRegNoVerified &&
        values?.mode !== 'manual'
      ) {
        errors.regNo =
          '* Click the search icon to fetch the Vehicle Details';
      }
      // else if(values?.vehicleRegNo?.bhseries === true && 
      //   values?.vehicleRegNo?.part1 &&
      //   values?.vehicleRegNo?.part2 &&
      //   values?.vehicleRegNo?.part3 &&
      //   values?.vehicleRegNo?.part4 &&
      //   BHstateCode.test(values?.vehicleRegNo?.part1) && 
      //     values?.vehicleRegNo?.part3?.match(/^[0-9]+$/) &&
      //   !values?.isRegNoVerified &&
      //   values?.mode !== 'manual'
      // ) {
      //   errors.regNo =
      //     '* Click the search icon to fetch the Vehicle Details';
      // }
    }
    // if (productCode1?.toString() !== '3176') {
    // if (
    //   values?.changedIDV === '' ||
    //   values?.changedIDV === null ||
    //   values?.changedIDV === undefined
    // ) {
    //   errors.changedIDV = '* Required';
    // }
    // if (values?.changedIDV) {
    //   if (
    //     values?.minSuggestedIDV &&
    //     parseFloat(values?.changedIDV) <
    //     parseFloat(values?.minSuggestedIDV)
    //   ) {
    //     errors.changedIDV = `* Changed IDV can't be less than ${values?.idvPctMin}% of suggested IDV`;
    //   }
    //   if (
    //     values?.maxSuggestedIDV &&
    //     parseFloat(values?.changedIDV) >
    //     parseFloat(values?.maxSuggestedIDV)
    //   ) {
    //     errors.changedIDV = `* Changed IDV can't be greater than ${values?.idvPctMax}% of suggested IDV`;
    //   }
    // }
    // if (
    //   values?.adjustmentIRF === '' ||
    //   values?.adjustmentIRF === null ||
    //   values?.adjustmentIRF === undefined
    // ) {
    //   errors.adjustmentIRF = '* Required';
    // }
    // if (
    //   values?.adjustmentIRF &&
    //   parseFloat(values?.adjustmentIRF) < -parseFloat(values?.irfPctMin)
    // ) {
    //   errors.adjustmentIRF = `* IRF can't be less than -${values?.irfPctMin}%`;
    // }
    // if (
    //   values?.adjustmentIRF &&
    //   parseFloat(values?.adjustmentIRF) > parseFloat(values?.irfPctMax)
    // ) {
    //   errors.adjustmentIRF = `* IRF can't be more than ${values?.irfPctMax}%`;
    //   }
    // }
    if (!values?.vehicleIsOwnedBy) {
      errors.vehicleIsOwnedBy = '* Required';
    }
    if (
      values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
      'yes' &&
      (values?.businessType?.toLowerCase() === 'roll over' ||
      values?.businessType?.toLowerCase() === 'new business')
      //  || values?.businessType?.toLowerCase() === 'used car'
    ) {
      if (!values?.policyCoverType) {
        errors.policyCoverType = '* Required';
      }
      // if (!values?.policyTenure) {
      //  errors.policyTenure = '* Required';
      // }
      if (!values?.policyStartDate) {
        errors.policyStartDate = '* Required';
      }
      if (
        values?.policyStartDate &&
        moment(values?.policyStartDate, 'DD/MM/YYYY')?.isAfter()
      ) {
        errors.policyStartDate = '* Cannot accept future date';
      } else if (
        values?.policyStartDate &&
        values?.policyExpiryDate &&
        moment(values?.policyStartDate, 'DD/MM/YYYY')?.isAfter(
          moment(values?.policyExpiryDate, 'DD/MM/YYYY'),
        )
      ) {
        errors.policyStartDate = `* Start Date can't be after end date`;
      }
      // SA BT29521/IM5202088
      /** else if (
        values?.policyStartDate &&
        values?.dateOfReg &&
        moment(values?.policyStartDate, 'DD/MM/YYYY')?.isBefore(
          moment(values?.dateOfReg, 'DD/MM/YYYY'),
        )) {
        errors.policyStartDate = `* Start Date can't be less than Date of Registration`;
      } */
      //EA BT29521/IM5202088 
      if (!values?.policyExpiryDate) {
        errors.policyExpiryDate = '* Required';
      } else if (
        values?.policyStartDate &&
        values?.policyExpiryDate &&
        moment(values?.policyStartDate, 'DD/MM/YYYY')?.isAfter(
          moment(values?.policyExpiryDate, 'DD/MM/YYYY'),
        )
      ) {
        errors.policyExpiryDate = `* End date date can't be less than start date`;
      }
     
      // if (
      //   values?.policyExpiryDate &&
      //   moment(values?.policyExpiryDate, 'DD/MM/YYYY')?.isAfter()
      // ) {
      //   errors.policyExpiryDate = '* Cannot accept future date';
      // }
      const expectedTPPolicyEndDate = moment(
        values?.TP_End_Date,
        'DD/MM/YYYY',
      )
      .add(1,'days')
      .subtract(3, 'years')
      .format('DD/MM/YYYY')
      if (
        values?.TP_Start_Date &&
        values?.TP_End_Date &&
        expectedTPPolicyEndDate !==
        moment(values?.TP_Start_Date, 'DD/MM/YYYY').format('DD/MM/YYYY')
      ) {
        errors.TP_End_Date = `* Date range should be exactly 3 year`;
        errors.TP_Start_Date = `* Date range should be exactly 3 year`;
      }
      //values.productType === 'Kotak Car Secure OD Only'&& 
      if ( 
        values?.businessType?.toLowerCase() === 'new business' &&
         values?.policyExpiryDate &&
         moment(values?.policyExpiryDate, 'DD/MM/YYYY')?.isAfter()
       ) {
          errors.policyExpiryDate = '* Cannot accept future date';
       }else if (values?.policyExpiryDate && moment(values?.policyExpiryDate, 'DD/MM/YYYY').diff(
        moment(moment(new Date(), 'DD/MM/YYYY')?.format('DD/MM/YYYY'), 'DD/MM/YYYY'), 'days') > 90)
      {
          errors.policyExpiryDate = `Cannot choose future date more than 90 days from current date`;
      }
      if (values?.policyTenure) {
        // if (
        //   (values?.policyTenureValue
        //     ?.toLowerCase()
        //     ?.search('long term') !== -1 &&
        //     !values?.totalClaimAmount) ||
        //   (values?.policyTenureValue
        //     ?.toLowerCase()
        //     ?.search('annual') !== -1 &&
        //     parseFloat(values?.totalClaimCountValue) !== 0 &&
        //     !values?.totalClaimAmount)
        // ) {
        //   errors.totalClaimAmount = '* Required';
        // }
        if (parseFloat(values?.totalClaimAmount) < 0) {
          errors.totalClaimAmount = '* Amount should be positive';
        }
        if (!values?.previousYearNCBSlab) {
          errors.previousYearNCBSlab = '* Required';
        }
        const expectedPolicyEndDateForAnnual = moment(
          values?.policyStartDate,
          'DD/MM/YYYY',
        )
          ?.add(1, 'year')
          ?.subtract(1, 'day');
       
      }
      // if (
      //   values?.policyTenureValue
      //     ?.toLowerCase()
      //     ?.search('long term') !== -1
      // ) {
      //   if (!values?.noOfClaimsOneYear) {
      //     errors.noOfClaimsOneYear = '* Required';
      //   }
      //   if (!values?.noOfClaimsTwoYears) {
      //     errors.noOfClaimsTwoYears = '* Required';
      //   }
      //   if (!values?.noOfClaimsThreeYears) {
      //     errors.noOfClaimsThreeYears = '* Required';
      //   }
      // } else if (
      //   values?.policyTenureValue?.toLowerCase()?.search('annual') !==
      //   -1
      // ) {
      //   if (!values?.totalClaimCount) {
      //     errors.totalClaimCount = '* Required';
      //   }
      // }
    }
    if (values.getAdditionalCreditScore === 'Yes') {
      if (!values?.idProofType) {
        errors.idProofType = '* Required';
      }
      if (!values?.idProofNumber) {
        errors.idProofNumber = '* Required';
      }
      if (!values?.cs_proposer_first_name) {
        errors.cs_proposer_first_name = '* Required';
      }
      if (!values?.cs_proposer_last_name) {
        errors.cs_proposer_last_name = '* Required';
      }
      if (!values?.cs_proposer_mobileNo) {
        errors.cs_proposer_mobileNo = '* Required';
      }
      if (values?.cs_proposer_mobileNo > 1) {
        if (
          values?.cs_proposer_mobileNo.toString().length !==
          10 ||
          !values?.cs_proposer_mobileNo
            .toString()
            .match(/^[0-9]+$/)
        ) {
          errors.cs_proposer_mobileNo =
            '* Mobile number must be of 10 digits';
        }
      }
      if (!values?.cs_proposerDOB) {
        errors.cs_proposerDOB = '* Required';
      }
    }
    //check------------------------------------
    if (values.idProofNumber) {
      let regPassport = /^([a-zA-Z]){1}([0-9]){7}?$/;
      if (
        values.idProofType ===
        getDomainData(
          PRD_IDProofTypeForCreditScoreList,
          'Passport',
          'value',
          'code',
        )
      ) {
        if (values.idProofNumber.length !== 8) {
          errors.idProofNumber =
            '* Passport number must be of 8 digits';
        } else if (!regPassport.test(values.idProofNumber)) {
          errors.idProofNumber = '* Enter valid passport number';
        }
      }
      if (
        values.idProofType ===
        getDomainData(
          PRD_IDProofTypeForCreditScoreList,
          'PAN Card',
          'value',
          'code',
        )
      ) {
        if (values.idProofNumber.length !== 10) {
          errors.idProofNumber = '* PAN number must be of 10 digits';
        } else if (
          !/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(
            values.idProofNumber,
          )
        ) {
          errors.idProofNumber = '* Please enter valid PAN number';
        }
      }
      //end-------------------------------------------------------
    }
    // if (!values?.pincode) {
    //   errors.pincode = '* Required';
    // } else if (
    //   values.pincode &&
    //   (values.pincode.length !== 6 ||
    //     !values.pincode.match(/^[0-9]+$/))
    // ) {
    //   errors.pincode = '* Pincode must be of 6 digits';
    // } else if (
    //   values.pincode &&
    //   values.pincode.length === 6 &&
    //   !values.state
    // ) {
    //   errors.pincode = '* Click the search icon to fetch state';
    // }
    return errors;
  };
  const update_cover_data = (values) => {
    coversInfo?.applicableCovers?.riskCovers.map((riskCover, idx) => (
      riskCover.covers.map((cover, idx) => {
        cover?.name === values?.addOnCovers
      }
      )
    )
    )

  }
  const onSubmit =  async (values) => {
    if(values.isMakeDeclined){
      setParentAlerts([
        {
          header: 'Warning',
          id: Date.now(),
          content: (
            <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
              <span>
                   Model is Declined, Quote cannot be created
              </span>
            </div>
          ),
          type: 'warning',
          timeout: null,
          disableClose: false,
        },
      ]);
      return false;
    }
    let creditScoreVal = 0;
    if(values?.getAdditionalCreditScore?.toString()?.toLowerCase() === 'yes'){
    let queryOutput = fetchQuery({
      query: GET_CREDIT_SCORE_DTLS,
      fetchPolicy: 'catch-first',
      variables: {
        input:{
          idProofType: values?.idProofType ? values?.idProofType : "",
            idProofNumber: values?.idProofNumber ? values?.idProofNumber: '',
            firstName: values?.cs_proposer_first_name ? values?.cs_proposer_first_name: '',
            lastName: values?.cs_proposer_last_name ? values?.cs_proposer_last_name: '',
            mobileNo:values?.cs_proposer_mobileNo ? values?.cs_proposer_mobileNo: '',
            proposerDOB:values?.cs_proposerDOB ? values?.cs_proposerDOB: '',
        }
      },
    });
    setLoadingStep(true)
    const {data :queryData} =  await queryOutput;
    setLoadingStep(false)
    const {getCreditScoreDtls} = queryData;
      creditScoreVal = getCreditScoreDtls?.creditScore;
    }
    setParentAlerts([]);
    updateMotorQuote({
      ...values,
      creditScore: values?.getAdditionalCreditScore?.toString()?.toLowerCase() === 'yes'
         ? creditScoreVal : null,
      cs_proposer_first_name:values?.getAdditionalCreditScore?.toString()?.toLowerCase() === 'yes'
         ? values?.cs_proposer_first_name : null,
      cs_proposer_middle_name:values?.getAdditionalCreditScore?.toString()?.toLowerCase() === 'yes'
         ? values?.cs_proposer_middle_name : null,
      cs_proposer_last_name:values?.getAdditionalCreditScore?.toString()?.toLowerCase() === 'yes'
         ? values?.cs_proposer_last_name : null,
      cs_proposer_mobileNo:values?.getAdditionalCreditScore?.toString()?.toLowerCase() === 'yes'
         ? values?.cs_proposer_mobileNo : null,
      cs_proposerDOB:values?.getAdditionalCreditScore?.toString()?.toLowerCase() === 'yes'
         ? values?.cs_proposerDOB : null,
      anyPreviousPolicyforVehicleTakenOnQuote: values?.anyPreviousPolicyforVehicleTaken
      ?.toString()
      ?.toLowerCase() === 'yes' ?'Yes':'No',
      prevInsurance: {
        insurerName:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.insurerName
            : '',
        policyNumber:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.policyNumber
            : '',
        expiryDate:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.expiryDate
            : '',
        startDate:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.startDate
            : '',
        coverType:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.coverType
            : '',
        policyTenure:
          values?.anyPreviousPolicyforVehicleTaken
            ?.toString()
            ?.toLowerCase() === 'yes'
            ? values?.prevInsurance?.policyTenure
            : '',
      },
      isPrevInsuranceAvailable:
        values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'no'
          ? null
          : values?.isPrevInsuranceAvailable,
      isPrevClaimsAvailable:
        values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'no'
          ? null
          : values?.isPrevClaimsAvailable,
      policyCoverType:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business') &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
          ? values?.policyCoverType
          : '',
      policyTenure:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business') &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
          ? values?.policyTenure
          : '',
      policyTenureValue:
       ( values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business') &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
          ? values?.policyTenureValue
          : '',
      policyStartDate:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business') &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
          ? values?.policyStartDate
          : '',
      policyExpiryDate:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business') &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
          ? values?.policyExpiryDate
          : '',
      totalClaimCount:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business' )&&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes' 
          ? values?.totalClaimCount
          : '',
      totalClaimCountValue:
       ( values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business') &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes' 
          ? values?.totalClaimCountValue
          : '',
      noOfClaimsOneYear:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business') &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes' 
          ? values?.noOfClaimsOneYear
          : '',
      noOfClaimsTwoYears:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business') &&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes' 
          ? values?.noOfClaimsTwoYears
          : '',
      noOfClaimsThreeYears:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'new business' )&&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes' 
          ? values?.noOfClaimsThreeYears
          : '',
      totalClaimAmount:
        (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.toLowerCase() ===
          'new business' )&&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
          ? values?.totalClaimAmount
          : '',
      previousYearNCBSlab:
          (values?.businessType?.toString()?.trim()?.toLowerCase() ===
          'roll over' || values?.businessType?.toString()?.toLowerCase() ===
          'new business' )&&
          values?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
          ? values?.previousYearNCBSlab
          : '',
      isVehicleDetailsAvailable: true,
      regNo: `${values?.vehicleRegNo?.part1}${values?.vehicleRegNo?.part2}${values?.vehicleRegNo?.part3}${values?.vehicleRegNo?.part4}`,
      zoopCustDtls: values?.zoopCustDtls,
      coverData: {
        addOnCovers :  coversInfo?.applicableCovers?.riskCovers.map((riskCover, idx) => {
          return {
            riskType: riskCover?.riskType,
            covers: riskCover?.covers?.map((cover) => {
              return {
                name: cover?.name,
                index: cover?.index,
                selected: (values?.isQuoteCopied && values.businessType !== motorQuote?.businessType && values?.businessType == 'Roll Over')
                  || values.businessType !== motorQuote?.businessType || values.vehicleAge !== motorQuote?.vehicleAge
                  ? false
                  : (values.vehicleOwnerTypeAndGender.organisationType === 'Individual'
                    && cover?.name == 'Owner Driver')
                    ? true
                    : (values.vehicleOwnerTypeAndGender.organisationType === 'Corporate'
                      && cover?.name == 'Owner Driver')
                    ? false
                  : !values?.quotationNo 
                && values.vehicleOwnerTypeAndGender.organisationType==='Corporate'&& cover?.name=='Legal Liability for Employees other than paid driver conductor cleaner'
                ?true
                :!values?.quotationNo 
                  ? values?.addOnCovers !== undefined  && values?.addOnCovers[cover?.name]
                    ? values?.addOnCovers[cover?.name]?.selected 
                    : motorQuote?.coverData?.addOnCovers?.find(
                      (riskCov) =>riskCov?.riskType === riskCover?.riskType)?.covers?.find(
                        (cov) => cov?.name === cover?.name)?.selected || false
                  : motorQuote?.coverData?.addOnCovers?.find(
                    (riskCov) =>riskCov?.riskType === riskCover?.riskType)?.covers?.find(
                      (cov) => cov?.name === cover?.name)
                    ? motorQuote?.coverData?.addOnCovers?.find(
                      (riskCov) =>riskCov?.riskType === riskCover?.riskType)?.covers?.find(
                        (cov) => cov?.name === cover?.name)?.selected
                    : false,
                  disabled:
                    (cover?.name==='Consumable Cover'&&values?.addOnCovers?.['Depreciation Cover']?.selected&&values?.dep_selected)
                    ||(cover?.name==='Road Side Assistance'&&values?.addOnCovers?.['Depreciation Cover']?.selected)
                    ||(cover?.name==='Depreciation Cover'&&values?.addOnCovers?.['Return to Invoice']?.selected)
                    ||(cover?.name==='Depreciation Cover'&&values?.addOnCovers?.['Engine Protect']?.selected)
                    ||  (cover?.name==='Depreciation Cover'&&values?.addOnCovers?.['Consumable Cover']?.selected&& !values?.dep_selected)
                    ? true : false,
                attributes: !values?.quotationNo
                  ?  (motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                      ?.covers?.find((cov) => (cov?.name === cover?.name && cov?.index === 'N093891G0058') ))
                      ? (motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                          ?.covers?.find((cov) =>
                            (cov?.name === cover?.name && cov?.index === 'N093891G0058')
                          ))?.attributes?.map((e) => {
                            if (e?.displayName === 'No. of passengers') {
                              return {
                                ...e,
                                value: values?.seatingCapacity,
                              }
                            } else {
                              return e;
                            }
                          })
                        : motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                        ?.covers?.find((cov) => cov?.name === cover?.name)?.attributes || cover?.attributes
                  : motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                    ?.covers?.find((cov) => cov?.name === cover?.name)
                      ? 
                        motorQuote?.coverData?.addOnCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                        ?.covers?.find((cov) => cov?.name === cover?.name)?.attributes
                    
                      : cover?.attributes
                    ,
              }
            })
          }
        }),
        rawRiskData:coversInfo?.applicableCovers?.riskCovers,
        productVariant:values?.productVariant
      },
      productCode:productCode1,
    });

    if(values?.isProposalModify){
      updateMotorQuote({
        proposalNumber: values?.proposalNumber,
        proposalData:{
          ...values?.proposalData,
          additionalTabDetails: {
            ...values?.proposalData?.additionalTabDetails,
            previousInsuranceAndClaims:{
              previousPolicyDetails: {
                TPpreviousInsurerName: values?.proposalData?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.TPpreviousInsurerName
                ? `${values?.proposalData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.TPpreviousInsurerName}`
                :  '',
              TPexpiringPolicyNumber: values?.proposalData?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.TPexpiringPolicyNumber
                ? `${values?.proposalData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.TPexpiringPolicyNumber}`
                : '',
              previousInsurerName: values?.proposalData?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName
                ? `${values?.proposalData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
                : '',
              expiringPolicyNumber: values?.proposalData?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.expiringPolicyNumber
                ? `${values?.proposalData?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
                : '',
              }
            },
          },
          vehicleTabDetails:{
            vehicleRegistrationDetails:{
              engineNumber: values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.engineNumber
              ? `${values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
                ?.engineNumber}`
              : '',
            chasisNumber: values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.chasisNumber
              ? `${values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
              : '',
            preInspectionNumber:values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
              ?.preInspectionNumber
              ? `${values?.proposalData?.vehicleTabDetails?.vehicleRegistrationDetails
                  ?.preInspectionNumber}`
              :'',
            }
          }
        }
      })
     }
    setproceedToCoverPage(true);
    return true;
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
      `${returnType}`
      ]
      : '';
  };

  const VehicleForm = ({ validate, coversInfo }) => {
    const { values, setFieldValue, submitForm } =
      useQuantaFormikContext();
    const [loadingBusinessType, setLoadingBusinessType] =
      useState(false);
    const [loadingVehicleDetials, setLoadingVehicleDetials] =
      useState(false);
    const [loadingClaimDetails, setLoadingClaimDetails] =
      useState(false);
    const [errorClaimDetails, setErrorClaimDetails] = useState(null);
    const [errorBusinessType, setErrorBusinessType] = useState(null);
    const [businessType, setBusinessType] = useState(null);
    const [errorFLADetails, setErrorFLADetails] = useState(null);
    const [showVehicleDetailsModal, setShowVehicleDetailsModal] =
      useState(false);
    const [vehicleDetailValues, setVehicleDetailValues] = useState(
      values?.make?.code
        ? {
          make: {
            code: values?.make?.code ? values?.make?.code : '',
            value: values?.make?.value ? values?.make?.value : '',
          },
          variant: {
            variantCode: values?.variant?.code
              ? values?.variant?.code
              : '',
            variantName: values?.variant?.value
              ? values?.variant?.value
              : '',
          },
          model: {
            code: values?.model?.code ? values?.model?.code : '',
            value: values?.model?.value ? values?.model?.value : '',
          },
          segmentType: values?.segmentType 
            ? values?.segmentType
            : '',
          seatingCapacity: values?.seatingCapacity
            ? values?.seatingCapacity
            : '',
          fuelType: values?.fuelType ? values?.fuelType : '',
          cubeCapacity: values?.cubeCapacity
            ? values?.cubeCapacity
            : '',
          yearOfManufacture: values?.yearOfManufacture
            ? values?.yearOfManufacture
            : '',
          dateOfReg: values?.dateOfReg ? values?.dateOfReg : '',
          rtoLocationCode: values?.rtoLocationCode
            ? values?.rtoLocationCode
            : '',
          rtoLocationDesc: values?.rtoLocationDesc
            ? values?.rtoLocationDesc
            : '',
          rtoAuthorityCode: values?.rtoAuthorityCode
            ? values?.rtoAuthorityCode
            : '',
          registrationNo: values?.regNo ? values?.regNo : '',
          chasisNo: values?.chasisNo ? values?.chasisNo : '',
          engineNo: values?.engineNo ? values?.engineNo : '',
          isRegNoVerified: values?.isRegNoVerified,
          isZoopServiceCalled: values?.isZoopServiceCalled,
          isMakeDeclined: values?.isMakeDeclined ? true : false ,
          mode: values?.mode,
          vehicleAge : values?.vehicleAge,
        }
        : null,
    );
    const vehicleDtls = useRef();
    const vehicleDtlsFetch = async ({getVehicleDetails,vehicleRegNo}) =>{
      try {
        
        if (getVehicleDetails) {
          const { part1, part2, part3, part4, bhseries } = vehicleRegNo;
          const rtoBrandYearQuery = fetchQuery({
            query: RTO_LIST_BRAND_LIST_YEAR_RANGE,
            variables: {
              filterMakeList: {
                productCode: productCode1?.toString()?.toLowerCase(),
              },
              type: 'Year of Manufacture',
            },
          });
          const { data: MakeDetails } = await rtoBrandYearQuery;
          const { makeList } = MakeDetails;
          const vehicleModelquery = fetchQuery({
            query: MODEL_DETAILS,
            variables: {
              filter: {
                productCode: productCode1?.toString()?.toLowerCase(),
                makeCode: getVehicleDetails?.make?.code,
              },
            },
          });
          const vehicleVariantquery = fetchQuery({
            query: VARIANT_DETAILS,
            variables: {
              filter: {
                productCode: productCode1?.toString()?.toLowerCase(),
                makeCode: getVehicleDetails?.make?.code,
                modelCode: getVehicleDetails?.model?.code,
              },
            },
          });
          const rtoSearchquery = fetchQuery({
            query: GET_RTO_DETAILS,
            variables: {
              input: {
                rtoCode: getVehicleDetails?.rto?.rtoAuthCode?.toString()
                  || getVehicleDetails?.rtoAuthorityCode?.toString()
                  || `${part1}${part2}`,
                productCode: productCode1?.toString()?.toLowerCase(),

              },
            },
          });
          const { data: modelData } = await vehicleModelquery;
          const { data: variantData } = await vehicleVariantquery;
          const { data: rtoData} = await rtoSearchquery;
          const variantDtls = variantData?.variantList?.find(
            (vl) =>
              vl?.variantName?.trim()?.toLowerCase() ===
              getVehicleDetails?.variant?.code?.trim()
                ?.toLowerCase(),
          );
          vehicleDtls.current = {
            mode: getVehicleDetails?.mode || 'manual',
            isRegNoVerified: getVehicleDetails?.isRegNoVerified ,
            isZoopServiceCalled: getVehicleDetails?.isZoopServiceCalled,
            isMakeDeclined: getVehicleDetails?.isDeclined,
            make: getVehicleDetails?.make,
            model: getVehicleDetails?.model,
            makeList: makeList,
            modelList: modelData?.modelList,
            rtoList:  rtoData?.RTODtlsSearch?.rto,
            variantList: variantData?.variantList,
            variant: {
              code: getVehicleDetails?.variant?.code 
                || getVehicleDetails?.variant?.variantCode ,
              value: //`${variantDtls?.variantName} # ${variantDtls?.fuel} # ${variantDtls?.cubeCapacity}`,
              getVehicleDetails?.variant?.value 
              ?  `${getVehicleDetails?.model?.value} - ${getVehicleDetails?.variant?.value} # ${getVehicleDetails?.fuelType} # ${getVehicleDetails?.cubicCapacity}`
              :  getVehicleDetails?.variant?.variantName?.search(getVehicleDetails?.model?.value) !== -1
                ? `${getVehicleDetails?.variant?.variantName} # ${getVehicleDetails?.fuelType} # ${getVehicleDetails?.cubeCapacity}`
                : `${getVehicleDetails?.model?.value} - ${getVehicleDetails?.variant?.variantName} # ${getVehicleDetails?.fuelType} # ${getVehicleDetails?.cubeCapacity}`
             },
            fuelType: getVehicleDetails?.fuelType,
            seatingCapacity: getVehicleDetails?.seatingCapacity ,
            segmentType: getVehicleDetails?.segmentType  ||
              variantDtls?.segmentType,
            cubeCapacity: getVehicleDetails?.cubicCapacity
              || getVehicleDetails?.cubeCapacity,
            yearOfManufacture: getVehicleDetails?.manufactureYear
              || getVehicleDetails?.yearOfManufacture,
            dateOfReg: getVehicleDetails?.regPurchaseDate
              || getVehicleDetails?.dateOfReg,
            rtoLocationCode: getVehicleDetails?.rto?.rtoLocCode || getVehicleDetails?.rtoLocationCode
              ? getVehicleDetails?.rto?.rtoLocCode || getVehicleDetails?.rtoLocationCode
              : '',
            rtoLocationDesc: getVehicleDetails?.rto?.rtoLocDesc || getVehicleDetails?.rtoLocationDesc
              ? getVehicleDetails?.rto?.rtoLocDesc || getVehicleDetails?.rtoLocationDesc
              : '',
            rtoAuthorityCode: getVehicleDetails?.rto?.rtoAuthCode || getVehicleDetails?.rtoAuthorityCode
              ? getVehicleDetails?.rto?.rtoAuthCode || getVehicleDetails?.rtoAuthorityCode 
              : '',
            rtoAuthAndLocationDesc: (getVehicleDetails?.rto?.rtoAuthCode || getVehicleDetails?.rtoAuthorityCode)
              ? `${getVehicleDetails?.rto?.rtoAuthCoden
                  || getVehicleDetails?.rtoAuthorityCode}-${getVehicleDetails?.rto?.rtoLocDesc
                  || getVehicleDetails?.rtoLocationDesc}`
                : '',
            registrationNo: `${part1}${part2}${part3}${part4}`,
            engineNo: getVehicleDetails?.engineNumber
              || getVehicleDetails?.engineNo,
            chasisNo: getVehicleDetails?.chasisNumber 
              || getVehicleDetails?.chasisNo , 
            carryingCapacity: getVehicleDetails?.carryingCapacity,
            financerName: getVehicleDetails?.financerName,
            prevInsurance: getVehicleDetails?.prevInsurance,
          }
        }
      }
      catch (error) {
        console.log(error);
      }
    }
    useEffect(() => {
      if (!values?.vehicleIsOwnedBy) {
        setFieldValue(
          'vehicleIsOwnedBy', PRD_vehicleOwnedByList[0]?.code)
        setFieldValue(`vehicleOwnerTypeAndGender`, {
          gender: PRD_vehicleOwnedByList[0]?.code
            ?.split('#')[1]
            ?.trim()
            ? PRD_vehicleOwnedByList[0]?.code
              ?.split('#')[1]
              ?.trim()
            : '',
          organisationType: PRD_vehicleOwnedByList[0]?.code
            ?.split('#')[0]
            ?.trim()
            ? PRD_vehicleOwnedByList[0]?.code
              ?.split('#')[0]
              ?.trim()
            : '',
        });
        setFieldValue(`addOnCovers[Owner Driver].selected`, true);
      }
      if (productCode?.toString()=='3176'){
        setFieldValue(`productVariant`, 
          productVariantList?.find((d) => d.value === '3176')?.code);
      }
      if (productCode?.toString()=='3151'){
        setFieldValue(`productVariant`, productVariantList?.find((d) => d.value === '3151')?.code);
      }
      if (values?.productVariant=='') {
        setFieldValue(`productVariant`, productVariantList?.find((d) => d.value === '3121')?.code,);
      }

      if (!values?.productType || !values?.productTypeValue) {
        if (values?.productvariant?.toLowerCase()?.search('comprehensive') !== -1) {

          setFieldValue(`productType`, lobProductList
            ?.find(
              (lpl) =>
                lpl?.lob_code?.toString()?.toLowerCase() ===
                lobCode?.toString()?.toLowerCase(),
            )
            ?.products?.find(
              (prd) =>
                prd?.product_code
                  ?.toString()
                  ?.toLowerCase() ===
                productCode1?.toString()?.toLowerCase(),
            )
            ?.product_types?.[0]?.value);
            setFieldValue(`productTypeValue`, lobProductList
            ?.find(
              (lpl) =>
                lpl?.lob_code?.toString()?.toLowerCase() ===
                lobCode?.toString()?.toLowerCase(),
            )
            ?.products?.find(
              (prd) =>
                prd?.product_code
                  ?.toString()
                  ?.toLowerCase() ===
                productCode1?.toString()?.toLowerCase(),
            )
            ?.product_types?.[0]?.code);
          setFieldValue(`businessType`, 'Roll Over')
          setFieldValue(`anyPreviousPolicyforVehicleTaken`, 'Yes')
        }
        // else {
        //   console.log("inside else");

        //   setFieldValue(`productType`, lobProductList
        //   ?.find(
        //     (lpl) =>
        //       lpl?.lob_code?.toString()?.toLowerCase() ===
        //       lobCode?.toString()?.toLowerCase(),
        //   )
        //   ?.products?.find(
        //     (prd) =>
        //       prd?.product_code
        //         ?.toString()
        //         ?.toLowerCase() ===
        //       productCode?.toString()?.toLowerCase(),
        //   )
        //   ?.product_types?.[0]?.code);
        //    setFieldValue(`productType`, lobProductList
        //   ?.find(
        //     (lpl) =>
        //       lpl?.lob_code?.toString()?.toLowerCase() ===
        //       lobCode?.toString()?.toLowerCase(),
        //   )
        //   ?.products?.find(
        //     (prd) =>
        //       prd?.product_code
        //         ?.toString()
        //         ?.toLowerCase() ===
        //       productCode?.toString()?.toLowerCase(),
        //   )
        //   ?.product_types?.[0]?.value);
        // }
      }
      if (
        vehicleDetailValues !== null &&
        vehicleDetailValues !== undefined &&
        values
      ) {
        setFieldValue(
          `make`,
          vehicleDetailValues?.make
            ? vehicleDetailValues?.make
            : {
              code: values?.make?.code,
              value: values?.make?.value,
            },
        );
        setFieldValue(
          `model`,
          vehicleDetailValues?.model
            ? vehicleDetailValues?.model
            : {
              code: values?.model?.code,
              value: values?.model?.value,
            },
        );
        setFieldValue(`variant`, {
          code: vehicleDetailValues?.variant?.variantCode
            ? `${vehicleDetailValues?.variant?.variantCode}`
            : values?.variant?.code,
          value: vehicleDetailValues?.variant?.variantName
            ? vehicleDetailValues?.variant?.variantName?.trim()
            : values?.variant?.value,
        });
        setFieldValue(
          `rtoAuthorityCode`,
          vehicleDetailValues?.rtoAuthorityCode
            ? `${vehicleDetailValues?.rtoAuthorityCode}`
            : values?.rtoAuthorityCode,
        );
        setFieldValue(
          `rtoLocationCode`,
          vehicleDetailValues?.rtoLocationCode
            ? `${vehicleDetailValues?.rtoLocationCode}`
            : values?.rtoLocationCode,
        );
        setFieldValue(
          `rtoLocationDesc`,
          vehicleDetailValues?.rtoLocationDesc
            ? `${vehicleDetailValues?.rtoLocationDesc}`
            : values?.rtoLocationDesc,
        );
        setFieldValue(
          `chasisNo`,
          vehicleDetailValues?.chasisNo
            ? `${vehicleDetailValues?.chasisNo}`
            : values?.chasisNo,
        );
        setFieldValue(
          `engineNo`,
          vehicleDetailValues?.engineNo
            ? `${vehicleDetailValues?.engineNo}`
            : values?.engineNo,
        );
        setFieldValue(
          'financerName',
          vehicleDetailValues?.financerName
            ? `${vehicleDetailValues?.financerName}`
            : values?.financerName,
        );
        /**SUDivya : commented prevInsurance - zoop details was not displaying in proposal additional page */
        // setFieldValue(
        //   'prevInsurance',
        //   vehicleDetailValues?.prevInsurance
        //     ? `${vehicleDetailValues?.prevInsurance}`
        //     : values?.prevInsurance,
        // );
        setFieldValue(
          `seatingCapacity`,
          vehicleDetailValues?.seatingCapacity
            ? `${vehicleDetailValues?.seatingCapacity?.trim()}`
            : values?.seatingCapacity,
        );
        setFieldValue(
          `cubeCapacity`,
          vehicleDetailValues?.cubeCapacity
            ? `${vehicleDetailValues?.cubeCapacity}`
            : values?.cubeCapacity,
        );
        setFieldValue(
          `segmentType`,
          vehicleDetailValues?.segmentType
            ? `${vehicleDetailValues?.segmentType}`
            : values?.segmentType,
        );
        setFieldValue(
          'fuelType',
          vehicleDetailValues?.fuelType
            ? `${vehicleDetailValues?.fuelType}`
            : values?.fuelType,
        );
        setFieldValue(
          'regNo',
          vehicleDetailValues?.registrationNo
            ? `${vehicleDetailValues?.registrationNo}`
            : values?.regNo,
        );
        setFieldValue(
          'yearOfManufacture',
          vehicleDetailValues?.yearOfManufacture
            ? `${vehicleDetailValues?.yearOfManufacture}`
            : values?.yearOfManufacture,
        );
        setFieldValue(
          'dateOfReg',
          vehicleDetailValues?.dateOfReg
            ? `${vehicleDetailValues?.dateOfReg}`
            : values?.dateOfReg,
        );
        setFieldValue(
          'vehicleAge',
          vehicleDetailValues?.vehicleAge
            ? `${vehicleDetailValues?.vehicleAge}`
            : values?.vehicleAge,
        );
      }
      if(!vehicleDtls?.current && vehicleDetailValues !== null &&
        vehicleDetailValues !== undefined  ){
        let RegNo = values?.vehicleRegNo;
        let vehicleDetails ={
          ...vehicleDetailValues,
            // variant: {
            //   code: vehicleDetailValues?.variant?.variantCode,
            //   value: vehicleDetailValues?.variant?.variantName,
            // },
            carryingCapacity : values?.carryingCapacity,
            financerName: values?.financerName,
            prevInsurance : values?.prevInsurance,
        }
        vehicleDtlsFetch({
          getVehicleDetails:vehicleDetails, 
          vehicleRegNo:RegNo})
      }
    }, [vehicleDetailValues]);
    
    const onFLALookup = async ({ values, setFieldValue }) => {
      const { vehicleRegNo } = values;
      const { part1, part2, part3, part4 ,bhseries } = vehicleRegNo;
      if (
        validate(values)?.regNo ===
        '* Click the search icon to fetch the Vehicle Details' ||
        !validate(values)?.regNo
      ) {
        setFieldValue('regNo', `${part1}${part2}${part3}${part4}`);
        if (( !bhseries && 
          part1?.length === 2 &&
          part2?.length === 2 &&
          // part3?.length === 2 &&
          (part3?.length >= 0 && part3?.length <= 3) &&
          part4?.length === 4
            ) || (  bhseries &&   
                    part1?.length === 2 &&
                    part2?.length === 2 &&
                    part3?.length === 4 &&
                    (part4?.length >= 1 && part4?.length <= 3))
        ) {
          try {
            setErrorFLADetails(null);
            const flaDetails = fetchQuery({
              query: VEHICLE_DETAILS,
              fetchPolicy: 'network-only',
              variables: {
                input: {
                  regNo: `${part1}${part2}${part3}${part4}`,
                  rtoAuthCode: `${part1}${part2}`,
                  productCode: productCode1?.toString()?.toLowerCase(),
                },
              },
            });
            setLoadingVehicleDetials(true);
            const { data } = await flaDetails;
            const { getVehicleDetails } = data;
            const {
              make,
              model,
              variant,
              fuelType,
              seatingCapacity,
              cubicCapacity,
              segmentType,
              carryingCapacity,
              rto,
              manufactureYear,
              regPurchaseDate,
              engineNumber,
              chasisNumber,
              financerName,
              prevInsurance,
              isDeclined,
              customerDetails
            } = getVehicleDetails;
            if (
              // prevInsurance &&
              // (prevInsurance?.insurerName ||
              //   prevInsurance?.policyNumber ||
              //   prevInsurance?.expiryDate ||
              //   prevInsurance?.coverType ||
              //   prevInsurance?.startDate ||
              //   prevInsurance?.policyTenure) &&
              values?.businessType
                ?.toString()
                ?.trim()
                ?.toLowerCase() === 'roll over' 
                //|| values?.businessType?.toString()?.toLowerCase() === 'used car'
            ) {
              setFieldValue(
                `anyPreviousPolicyforVehicleTaken`,
                'Yes',
              );
              if (
                prevInsurance?.expiryDate ||
                prevInsurance?.startDate ||
                prevInsurance?.coverType ||
                prevInsurance?.policyTenure
              ) {
                setFieldValue(`isPrevInsuranceAvailable`, true);
              } else {
                setFieldValue(`isPrevInsuranceAvailable`, false);
              }
              if (productCode1?.toString()?.toLowerCase() === '3151'){
                setFieldValue(
                  `TP_End_Date`,
                  prevInsurance?.expiryDate
                    ? prevInsurance?.expiryDate
                    : '',
                );
                setFieldValue(
                  `TP_Start_Date`,
                  prevInsurance?.startDate
                    ? prevInsurance?.startDate
                    : moment(prevInsurance?.expiryDate, 
                      "DD/MM/YYYY").add(1, 'days').subtract(3, 'years').format('DD/MM/YYYY'),
                );
              }else{
                setFieldValue(
                  `policyExpiryDate`,
                  prevInsurance?.expiryDate
                    ? prevInsurance?.expiryDate
                    : '',
                );
                setFieldValue(
                  `policyStartDate`,
                  prevInsurance?.startDate
                    ? prevInsurance?.startDate
                    : moment(prevInsurance?.expiryDate, 
                      "DD/MM/YYYY").subtract(1, 'year').add(1, 'days').format('DD/MM/YYYY'),
                );
              }
              
              // setFieldValue(
              //   `policyCoverType`,
              //   prevInsurance?.coverType
              //     ? prevInsurance?.coverType
              //     : '',
              // );
              setFieldValue(
                `policyTenure`,
                prevInsurance?.policyTenure
                  ? prevInsurance?.policyTenure
                  : '',
              );
              setFieldValue(
                `policyTenureValue`,
                policyTermList?.PRD_PreviousPolicyTermList?.find(
                  (pT) =>
                    pT?.code?.toLowerCase() ===
                    prevInsurance?.policyTenure?.toLowerCase(),
                )?.value,
              );
            }
            setFieldValue(`zoopCustDtls`,
              customerDetails
            )
            setFieldValue(`prevInsurance`, prevInsurance);
            setFieldValue(`isRegNoVerified`, true);
            setFieldValue(`isMakeDeclined`, isDeclined);
            setFieldValue(`mode`, 'online');
            setFieldValue(`isZoopServiceCalled`, true);
            setVehicleDetailValues({
              mode: 'online',
              isRegNoVerified: true,
              isZoopServiceCalled:true,
              isMakeDeclined: isDeclined,
              make,
              model,
              variant: {
                variantCode: variant?.code,
                variantName: variant?.value,
              },
              fuelType,
              seatingCapacity,
              cubeCapacity: cubicCapacity,
              segmentType: segmentType,
              yearOfManufacture: manufactureYear,
              dateOfReg: regPurchaseDate,
              rtoLocationCode: rto?.rtoLocCode,
              rtoLocationDesc: rto?.rtoLocDesc,
              rtoAuthorityCode: rto?.rtoAuthCode,
              registrationNo: `${part1}${part2}${part3}${part4}`,
              engineNo: engineNumber,
              chasisNo: chasisNumber,
              carryingCapacity,
              financerName,
              prevInsurance,
            });

            vehicleDtlsFetch({getVehicleDetails,vehicleRegNo})
            setLoadingVehicleDetials(false);
            if (
              values?.businessType?.trim()?.toLowerCase() ===
              'roll over' 
             // || values?.businessType?.toString()?.trim()?.toLowerCase() === 'used car'
            ) {
              try {
                const fetchClaimDetails = fetchQuery({
                  query: CLAIM_DETAILS,
                  variables: {
                    input: {
                      regNo: `${part1}${part2}${part3}${part4}`,
                      rtoAuthCode: `${rto?.rtoAuthCode}`,
                    },
                  },
                });
                setLoadingClaimDetails(true);
                const { data } = await fetchClaimDetails;
                setLoadingClaimDetails(false);
                if (
              
                  data?.getClaimDetails?.claim_Status ||
                  data?.getClaimDetails?.prevNCBSlab
                ) {

                  if(data?.getClaimDetails?.claim_Status?.toLowerCase()=='no'){
                    setFieldValue(`disableNCB`,true)
                setFieldValue(
                      `previousYearNCBSlab`,data?.getClaimDetails?.prevNCBSlab
                );
                setFieldValue(
                      `totalClaimCount`,'No Claim'
                );
                  }
                  if(data?.getClaimDetails?.claim_Status?.toLowerCase()=='yes'){
                    if(values?.previousYearNCBList?.find((e)=>
                      e.value==data?.getClaimDetails?.prevNCBSlab)
                    ){
                setFieldValue(
                        `previousYearNCBSlab`,data?.getClaimDetails?.prevNCBSlab
                );
                setFieldValue(
                       `totalClaimCount`,'1 OD Claim'
                );
                      setFieldValue(`disableNCB`,true)
                    }
                    else{
                setFieldValue(
                      `previousYearNCBSlab`,''
                );
                    setFieldValue(`disableNCB`,false)
                setFieldValue(
                      `totalClaimCount`,''
                    );}
                  }
              }
              else{
                setFieldValue(`disableNCB`,false)
              }
              } catch (error) {
                setLoadingClaimDetails(false);
                setErrorClaimDetails(error.message);
                setFieldValue(`disableNCB`,false)
              }
            }
          } catch (error) {
            //setFieldValue(`anyPreviousPolicyforVehicleTaken`, 'No');
            setLoadingVehicleDetials(false);
            setVehicleDetailValues(null);
            setFieldValue(`isRegNoVerified`, false);
            setFieldValue(`isZoopServiceCalled`, false);
            setFieldValue(`isMakeDeclined`, null);
            setFieldValue(`mode`, 'online');
            setFieldValue(`make`, {
              code: '',
              value: '',
            });
            setFieldValue(`model`, {
              code: '',
              value: '',
            });
            setFieldValue(`variant`, {
              code: '',
              value: '',
            });
            setFieldValue(`rtoAuthorityCode`, '');
            setFieldValue(`rtoLocationCode`, '');
            setFieldValue(`rtoLocationDesc`, '');
            setFieldValue(`chasisNo`, '');
            setFieldValue(`engineNo`, '');
            setFieldValue('financerName', '');
            setFieldValue(`seatingCapacity`, '');
            setFieldValue(`cubeCapacity`, '');
            setFieldValue(`segmentType`, '');
            setFieldValue('fuelType', '');
            setFieldValue('regNo', '');
            setFieldValue('yearOfManufacture', '');
            setFieldValue('dateOfReg', '');
            setFieldValue(`prevInsurance`, {
              insurerName: '',
              policyNumber: '',
              expiryDate: '',
              startDate: '',
              coverType: '',
              policyTenure: '',
            });
            setFieldValue(`policyExpiryDate`, '',);
            setFieldValue(`policyStartDate`, '',);
            // setFieldValue(`policyCoverType`, '',);
            setFieldValue(`policyTenure`, '',);
            setFieldValue(`policyTenureValue`, '',);
            setFieldValue(`isPrevInsuranceAvailable`, false);
            setErrorFLADetails(error?.message);
          }
        }
      }
    };

    const [policyTermList, setPolicyTermList] = useState([]);

    const data = [
      {
        title: 'Product And Business Type',
        grid_data: [
          {
            type: 'select',
            label: (
              <>
                Product Variant<Text severity="error"> *</Text>
              </>
            ),
            name: 'productVariant',
            disabled: (values?.quotationNo !== '' && !modify ), 
            data: productVariantList &&
              productVariantList?.length > 0
              ? [...productVariantList?.map((val) => {
                return {
                  label: val?.code
                    ? `${val.code}`
                    : '',
                  value: val?.code
                    ? `${val.code}`
                    : '',
                }

              }),

              ]
              : [],
            onDataChange: async (val, setFieldValue) => {
              let productCode ;//SAEA BT17345
              productCode = productVariantList?.find((d) => d.code === val)?.value;
              setProductCode(productCode);
              setproductloading(productCode);
              if (val?.toLowerCase()?.search('comprehensive') !== -1 ){
                setFieldValue(`policyCoverType`, 'ComprehensivePolicy');
              }
              else if (val?.toLowerCase()?.search('liability') !== -1) {
                if(values?.productType?.toLowerCase()?.includes('1')){
                setFieldValue(`policyCoverType`, `LiabilityOnlyPolicy`);}
                else {
                  setFieldValue(`policyCoverType`, '1+3');
                }
              }
              else if (val?.toLowerCase()?.search('od') !== -1)
              {
                setFieldValue(`policyCoverType`, 'OD Only');
              }
              await refetch({productCode});//SAEA BT17345
            }
          },
          {
            type: 'select',
            label: (
              <>
                Product Type<Text severity="error"> *</Text>
              </>
            ),
            name: 'productType',
            disabled:
              loadingBusinessType ||  (values?.quotationNo !== '' && !modify),
            onDataChange: async (val, setFieldValue) => {
              try {
                setFieldValue(
                  `productTypeValue`,
                  lobProductList
                    ?.find(
                      (lpl) =>
                        lpl?.lob_code?.toString()?.toLowerCase() ===
                        lobCode?.toString()?.toLowerCase(),
                    )
                    ?.products?.find(
                      (prd) =>
                        prd?.product_code
                          ?.toString()
                          ?.toLowerCase() ===
                        productCode1?.toString()?.toLowerCase(),
                    )
                    ?.product_types?.find(
                      (p) =>
                        p?.value?.toLowerCase() === val?.toLowerCase(),
                    )?.code,
                );
                setFieldValue(
                  `productType`,
                  lobProductList
                    ?.find(
                      (lpl) =>
                        lpl?.lob_code?.toString()?.toLowerCase() ===
                        lobCode?.toString()?.toLowerCase(),
                    )
                    ?.products?.find(
                      (prd) =>
                        prd?.product_code
                          ?.toString()
                          ?.toLowerCase() ===
                        productCode1?.toString()?.toLowerCase(),
                    )
                    ?.product_types?.find(
                      (p) =>
                      p?.value?.toLowerCase() === val?.toLowerCase(),
                    )?.value,
                );
                if(values?.productType?.toLowerCase()?.includes('1')){
                  setFieldValue(`policyCoverType`, 'LiabilityOnlyPolicy');}
                  else {
                    setFieldValue(`policyCoverType`, '1+3');
                  }
                setErrorBusinessType(null);
                setBusinessType(null);
                const carSecureBusinessType = fetchQuery({
                  query: CAR_SECURE_BUSINESS_TYPE,
                  variables: {
                    filter: {
                      productCode,
                      productType: val?.toString(),
                    },
                  },
                });
                setLoadingBusinessType(true);
                const { data: businessTypeData } =
                  await carSecureBusinessType;
                setLoadingBusinessType(false);
                setFieldValue(
                  `businessType`,
                  businessTypeData?.getCarSecureBusinessType?.code,
                );
                setFieldValue(
                  `businessTypeValue`,
                  businessTypeData?.getCarSecureBusinessType?.value,
                );
                setBusinessType(
                  businessTypeData?.getCarSecureBusinessType?.value,
                );
                if(businessTypeData?.getCarSecureBusinessType?.value
                  ?.trim()
                  ?.toLowerCase() === 'used car' 
                  || businessTypeData?.getCarSecureBusinessType?.value
                  ?.trim()
                  ?.toLowerCase() === 'new business' 
                  ){
                    setFieldValue(
                      `anyPreviousPolicyforVehicleTaken`,
                      'No',
                    );
                    setFieldValue(`policyCoverType`, '');
                    setFieldValue(`policyTenure`, '');
                    setFieldValue(`policyTenureValue`, '');
                    setFieldValue(`policyStartDate`, '');
                    setFieldValue(`policyExpiryDate`, '');
                    setFieldValue(`totalClaimCount`, '');
                    setFieldValue(`totalClaimCountValue`, '');
                    setFieldValue(`noOfClaimsOneYear`, '');
                    setFieldValue(`noOfClaimsTwoYears`, '');
                    setFieldValue(`noOfClaimsThreeYears`, '');
                    setFieldValue(`totalClaimAmount`, '');
                    setFieldValue(`previousYearNCBSlab`, '');
                  }
                else if (
                  businessTypeData?.getCarSecureBusinessType?.value
                    ?.trim()
                    ?.toLowerCase() === 'roll over' 
                    //|| businessTypeData?.getCarSecureBusinessType?.value
                     
                     //?.toLowerCase() === 'used car'
                  //   &&
                  // values?.prevInsurance?.insurerName &&
                  // values?.prevInsurance?.expiryDate &&
                  // values?.prevInsurance?.policyNumber
                ) {
                  setFieldValue(
                    `anyPreviousPolicyforVehicleTaken`,
                    'Yes',
                  );
                  setFieldValue(`policyCoverType`, '');
                  setFieldValue(`policyTenure`, '');
                  setFieldValue(`policyTenureValue`, '');
                  setFieldValue(`policyStartDate`, '');
                  setFieldValue(`policyExpiryDate`, '');
                  // setFieldValue(`totalClaimCount`, '');
                  // setFieldValue(`totalClaimCountValue`, '');
                  setFieldValue(`totalClaimAmount`, '');
                  setFieldValue(`previousYearNCBSlab`, '');
                  if (values?.prevInsurance?.expiryDate) {
                    setFieldValue(
                      `policyExpiryDate`,
                      values?.prevInsurance?.expiryDate,
                    );
                  }
                }
              //   if (values?.vehicleIsOwnedBy?.organisationType!=='Corporate') {
              //   setFieldValue(`addOnCovers`,{
              //     "Owner Driver": {
              //       selected: true
              //     }
              //   });
              // }
              } catch (error) {
                setLoadingBusinessType(false);
                setFieldValue(`businessType`, '');
                setErrorBusinessType(error.message);
              }
            },
            data:
              lobProductList &&
                lobProductList?.length > 0 &&
                lobProductList?.find(
                  (lpl) =>
                    lpl?.lob_code?.toString()?.toLowerCase() ===
                    lobCode?.toString()?.toLowerCase(),
                )
                ? [
                  ...lobProductList
                    ?.find(
                      (lpl) =>
                        lpl?.lob_code?.toString()?.toLowerCase() ===
                        lobCode?.toString()?.toLowerCase(),
                    )
                    ?.products?.find(
                      (prd) =>
                        prd?.product_code
                          ?.toString()
                          ?.toLowerCase() ===
                        productCode1?.toString()?.toLowerCase(),
                    )
                    ?.product_types?.map((product_type) => {
                      return {
                        label: product_type?.code
                          ? product_type?.code
                          : '',
                          value: product_type?.value
                          ? product_type?.value
                          : '',
                      };
                    }),
                ]
                : [],
          },
          {
            type: 'render',
            name: 'businessType',
            colSpan:
              repeat === repeat_for_mobile ? repeat_for_mobile : null,
            component: () => (
              <div
                className={
                  repeat === repeat_for_mobile
                    ? 'flex flex-col items-baseline -mt-2'
                    : 'flex flex-col mt-2'
                }
              >
                <Text type="label" severity="info">
                  Business Type
                </Text>
                {loadingBusinessType && (
                  <Text
                    type="normal"
                    severity="info"
                    className="flex space-x-2"
                  >
                    <Text>
                      <FontAwesomeIcon icon={faSpinner} spin={true} />
                    </Text>
                    <Text>Fetching Business Type</Text>
                  </Text>
                )}
                {!loadingBusinessType && errorBusinessType && (
                  <Text
                    type="normal"
                    severity="error"
                    className="flex space-x-2"
                  >
                    <Text>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Text>
                    <Text>Error fetching business type</Text>
                  </Text>
                )}
                {!loadingBusinessType &&
                  !errorBusinessType &&
                  values?.businessType && (
                    <Text type="normal" className="flex space-x-2">
                      <Text severity="success">
                        <FontAwesomeIcon icon={faCheck} />
                      </Text>
                      <Text>{values?.businessType}</Text>
                    </Text>
                  )}
                {!loadingBusinessType &&
                  !errorBusinessType &&
                  !values?.businessType && (
                    <Text type="normal" severity="neutral">
                      <Text>Not Captured</Text>
                    </Text>
                  )}
              </div>
            ),
          },
          {
            type: 'select',
            size: 'large',
            label: (
              <>
                Vehicle is owned by<Text severity="error"> *</Text>
              </>
            ),
            disabled: (values?.quotationNo !== '' && !modify),
            name: 'vehicleIsOwnedBy',
            onDataChange: (val, setFieldValue) => {
              setFieldValue(`vehicleOwnerTypeAndGender`, {
                gender: val?.split('#')[1]?.trim()
                  ? val?.split('#')[1]?.trim()
                  : '',
                organisationType: val?.split('#')[0]?.trim()
                  ? val?.split('#')[0]?.trim()
                  : '',
              });
              if (
                getDomainData(PRD_vehicleOwnedByList, val, 'code', 'value')
                  ?.toString()
                  ?.trim()
                  ?.toLowerCase()
                  ?.startsWith('organisation')
              ) {
                setFieldValue(`getAdditionalCreditScore`, 'No');
                setFieldValue(`idProofType`, '');
                setFieldValue(`idProofNumber`, '');
              }
              if (
                getDomainData(PRD_vehicleOwnedByList, val, 'code', 'value')
                  ?.toString()
                  ?.trim()
                  ?.toLowerCase()
                  ?.startsWith('individual')&&values?.vehicleIsOwnedBy?.organisationType!=='Corporate'
              ){
                setFieldValue(`addOnCovers[Owner Driver].selected`, true);
              }else{
                setFieldValue(`addOnCovers[Owner Driver].selected`, false);
              }
            },
            data: PRD_vehicleOwnedByList
              ? [
                ...PRD_vehicleOwnedByList.map((vehicleIsOwnedBy) => {
                  return {
                    label: vehicleIsOwnedBy.value
                      ? vehicleIsOwnedBy.value
                      : '',
                    value: vehicleIsOwnedBy.code
                      ? vehicleIsOwnedBy.code
                      : '',
                  };
                }),
              ]
              : [],
          },

        ],
      },
      {
        title: 'Your Vehicle Details',
        grid_data: [
          values?.vehicleRegNo?.bhseries!==true
          ?
          {
            type: 'input-wrapper',
            size: 'full',
            fields: [
              'vehicleRegNo.part1',
              'vehicleRegNo.part2',
              'vehicleRegNo.part3',
              'vehicleRegNo.part4',
            ],
            disabled:
              loadingBusinessType
              || (values?.quotationNo !== '' && !modify) ,
            className: `${( values?.quotationNo !== '' && !modify) ||
              loadingBusinessType ||
              loadingVehicleDetials
              ? 'border-neutral-dark'
              : ''
              }`,
            children: (
              <>
                <QuantaInput
                  name="vehicleRegNo.part1"
                  maxLength="2"
                  size="full"
                  type="text"
                  placeholder="MH"
                  noerror
                  className="uppercase"
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType 
                    || (values?.quotationNo !== '' && !modify)
                  }
                  onKeyUp={(e) => {
                    if (e.target.value.length === 2) {
                      document
                        .getElementsByName('vehicleRegNo.part2')
                        .forEach((e) => e.focus());
                    }
                  }}
                  onKeyDown={({ key }) => {
                    const { vehicleRegNo } = values;
                    const { part1, part2, part3, part4 } =
                      vehicleRegNo;
                    if (
                      key === 'Enter' &&
                      (validate(values)?.regNo ===
                        '* Click the search icon to fetch the Vehicle Details' ||
                        !validate(values)?.regNo) &&
                      part1?.length === 2 &&
                      part2?.length === 2 &&
                      // part3?.length === 2 &&
                      part3?.length === 2 &&
                      part4?.length === 4
                    ) {
                      onFLALookup({ values, setFieldValue });
                    }
                  }}
                  onDataChange={(val, setFieldValue) => {
                    setFieldValue(
                      `vehicleRegNo.part1`,
                      val?.toString()?.toUpperCase(),
                    );
                    setFieldValue(`isRegNoVerified`, null);
                    setFieldValue(`isMakeDeclined`, null);
                    setFieldValue(`isZoopServiceCalled`, null);
                    vehicleDtls.current ={
                       ...vehicleDtls?.current,
                       rtoList:[]
                    }
                  }}
                />
                <span
                  className={`flex items-center font-bold 
                  ${(values?.quotationNo !== '' && !modify) ||
                    loadingVehicleDetials ||
                    loadingBusinessType
                    ? 'bg-neutral-light'
                    : ''
                    } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleRegNo.part2"
                  maxLength="2"
                  size="full"
                  type="text"
                  placeholder="01"
                  noerror
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType 
                    || (values?.quotationNo !== '' && !modify)
                  }
                  onDataChange={(_) =>{
                    setFieldValue(`isRegNoVerified`, null)
                    setFieldValue(`isMakeDeclined`, null);
                    setFieldValue(`isZoopServiceCalled`, null);
                    vehicleDtls.current ={
                      ...vehicleDtls?.current,
                      rtoList:[]
                   }
                  }
                  }
                  onKeyUp={(e) => {
                    if (e.target.value.length === 2) {
                      document
                        .getElementsByName('vehicleRegNo.part3')
                        .forEach((e) => e.focus());
                    }
                  }}
                  onKeyDown={({ key }) => {
                    const { vehicleRegNo } = values;
                    const { part1, part2, part3, part4 } =
                      vehicleRegNo;
                    if (
                      key === 'Enter' &&
                      (validate(values)?.regNo ===
                        '* Click the search icon to fetch the Vehicle Details' ||
                        !validate(values)?.regNo) &&
                      part1?.length === 2 &&
                      part2?.length === 2 &&
                      // part3?.length === 2 &&
                      part3?.length === 2 &&
                      part4?.length === 4
                    ) {
                      onFLALookup({ values, setFieldValue });
                    }
                  }}
                />
                <span
                  className={`flex items-center font-bold 
                  ${(values?.quotationNo !== '' && !modify) ||
                    loadingVehicleDetials ||
                    loadingBusinessType
                    ? 'bg-neutral-light'
                    : ''
                    } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleRegNo.part3"
                    maxLength="3"
                  size="full"
                  type="text"
                    placeholder="CRS"
                  noerror
                  className="uppercase"
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType ||
                    (values?.quotationNo !== '' && !modify)
                  }
                  onKeyUp={(e) => {
                      if (e.target.value.length === 3) {
                      document
                        .getElementsByName('vehicleRegNo.part4')
                        .forEach((e) => e.focus());
                    }
                  }}
                  onKeyDown={({ key }) => {
                    const { vehicleRegNo } = values;
                    const { part1, part2, part3, part4 } =
                      vehicleRegNo;
                    if (
                      key === 'Enter' &&
                      (validate(values)?.regNo ===
                        '* Click the search icon to fetch the Vehicle Details' ||
                        !validate(values)?.regNo) &&
                      part1?.length === 2 &&
                      part2?.length === 2 &&
                        part3?.length <= 3 &&
                      part4?.length === 4
                    ) {
                      onFLALookup({ values, setFieldValue });
                    }
                  }}
                  onDataChange={(val, setFieldValue) => {
                    setFieldValue(
                      `vehicleRegNo.part3`,
                      val?.toString()?.toUpperCase(),
                    );
                    setFieldValue(`isRegNoVerified`, null);
                    setFieldValue(`isMakeDeclined`, null);
                    setFieldValue(`isZoopServiceCalled`, null);
                  }}
                />
                <span
                  className={`flex items-center font-bold
                   ${(values?.quotationNo !== '' && !modify)||
                    loadingVehicleDetials ||
                    loadingBusinessType
                    ? 'bg-neutral-light'
                    : ''
                    } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleRegNo.part4"
                  maxLength="4"
                  size="full"
                  type="text"
                  placeholder="2845"
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType || 
                    (values?.quotationNo !== '' && !modify)
                  }
                  onDataChange={(_) =>{
                    setFieldValue(`isRegNoVerified`, null);
                    setFieldValue(`isMakeDeclined`, null);
                    setFieldValue(`isZoopServiceCalled`, null);
                  }
                    
                  }
                  onKeyDown={({ key }) => {
                    const { vehicleRegNo } = values;
                    const { part1, part2, part3, part4 } =
                      vehicleRegNo;
                    if (
                      key === 'Enter' &&
                      (validate(values)?.regNo ===
                        '* Click the search icon to fetch the Vehicle Details' ||
                        !validate(values)?.regNo) &&
                      part1?.length === 2 &&
                      part2?.length === 2 &&
                      part3?.length === 2 &&
                      part4?.length === 4
                    ) {
                      onFLALookup({ values, setFieldValue });
                    }
                  }}
                  noerror
                />
                <QuantaButton
                  type="button"
                  className="w-32"
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType || 
                    (values?.quotationNo !== '' && !modify)
                  }
                  onClick={async ({
                    values,
                    isValid,
                    setFieldValue,
                  }) => {
                    onFLALookup({ values, setFieldValue });
                  }}
                >
                  {!loadingVehicleDetials && (
                    <FontAwesomeIcon icon={faSearch} />
                  )}
                  {loadingVehicleDetials && (
                    <FontAwesomeIcon icon={faSpinner} spin={true} />
                  )}
                </QuantaButton>
              </>
            ),
            label: (
              <>
                Enter Registration Number to find your Vehicle
                <Text></Text>
              </>
            ),
            name: 'regNo',
            // colSpan: repeat,
          }
          :
          {
            type: 'input-wrapper',
            size: 'full',
            fields: [
              'vehicleRegNo.part1',
              'vehicleRegNo.part2',
              'vehicleRegNo.part3',
              'vehicleRegNo.part4',
            ],
            disabled:
              loadingBusinessType
              || (values?.quotationNo !== '' && !modify),
            className: `${(values?.quotationNo !== '' && !modify) ||
              loadingBusinessType ||
              loadingVehicleDetials
              ? 'border-neutral-dark'
              : ''
              }`,
            children: (
              <>
                <QuantaInput
                  name="vehicleRegNo.part1"
                  maxLength="2"
                  size="full"
                  type="text"
                  placeholder="21"
                  noerror
                  className="uppercase"
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType ||
                     (values?.quotationNo !== '' && !modify)
                  }
                  onKeyUp={(e) => {
                    if (e.target.value.length === 2) {
                      document
                        .getElementsByName('vehicleRegNo.part2')
                        .forEach((e) => e.focus());
                    }
                  }}
                  onKeyDown={({ key }) => {
                    const { vehicleRegNo } = values;
                    const { part1, part2, part3, part4 } =
                      vehicleRegNo;
                    if (
                      key === 'Enter' &&
                      (validate(values)?.regNo ===
                        '* Click the search icon to fetch the Vehicle Details' ||
                        !validate(values)?.regNo) &&
                      part1?.length === 2 &&
                      part2?.length === 2 &&
                      // part3?.length === 2 &&
                      part3?.length === 4 &&
                      part4?.length === 2
                    ) {
                      onFLALookup({ values, setFieldValue });
                    }
                  }}
                  onDataChange={(val, setFieldValue) => {
                    setFieldValue(
                      `vehicleRegNo.part1`,
                      val?.toString()?.toUpperCase(),
                    );
                    setFieldValue(`isRegNoVerified`, null);
                    setFieldValue(`isMakeDeclined`, null);
                    setFieldValue(`isZoopServiceCalled`, null);
                  }}
                />
                <span
                  className={`flex items-center font-bold 
                  ${(values?.quotationNo !== '' && !modify) ||
                    loadingVehicleDetials ||
                    loadingBusinessType
                    ? 'bg-neutral-light'
                    : ''
                    } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleRegNo.part2"
                  maxLength="2"
                  size="full"
                  type="text"
                  placeholder="BH"
                  className="uppercase"
                  noerror
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType ||
                     (values?.quotationNo !== '' && !modify)
                  }
                  onDataChange={(_) =>{
                    setFieldValue(`isRegNoVerified`, null)
                    setFieldValue(`isMakeDeclined`, null);
                    setFieldValue(`isZoopServiceCalled`, null);
                  }
                  }
                  onKeyUp={(e) => {
                    if (e.target.value.length === 2) {
                      document
                        .getElementsByName('vehicleRegNo.part3')
                        .forEach((e) => e.focus());
                    }
                  }}
                  onKeyDown={({ key }) => {
                    const { vehicleRegNo } = values;
                    const { part1, part2, part3, part4 } =
                      vehicleRegNo;
                    if (
                      key === 'Enter' &&
                      (validate(values)?.regNo ===
                        '* Click the search icon to fetch the Vehicle Details' ||
                        !validate(values)?.regNo) &&
                      part1?.length === 2 &&
                      part2?.length === 2 &&
                      // part3?.length === 2 &&
                      part3?.length === 4 &&
                      part4?.length === 2
                    ) {
                      onFLALookup({ values, setFieldValue });
                    }
                  }}
                />
                <span
                  className={`flex items-center font-bold 
                  ${(values?.quotationNo !== '' && !modify) ||
                    loadingVehicleDetials ||
                    loadingBusinessType
                    ? 'bg-neutral-light'
                    : ''
                    } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleRegNo.part3"
                  maxLength="4"
                  size="full"
                  type="text"
                  placeholder="0000"
                  noerror
                  className="uppercase"
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType || 
                    (values?.quotationNo !== '' && !modify)
                  }
                  onKeyUp={(e) => {
                    if (e.target.value.length === 4) {
                      document
                        .getElementsByName('vehicleRegNo.part4')
                        .forEach((e) => e.focus());
                    }
                  }}
                  onKeyDown={({ key }) => {
                    const { vehicleRegNo } = values;
                    const { part1, part2, part3, part4 } =
                      vehicleRegNo;
                    if (
                      key === 'Enter' &&
                      (validate(values)?.regNo ===
                        '* Click the search icon to fetch the Vehicle Details' ||
                        !validate(values)?.regNo) &&
                      part1?.length === 2 &&
                      part2?.length === 2 &&
                      part3?.length === 4 &&
                      part4?.length === 2
                    ) {
                      onFLALookup({ values, setFieldValue });
                    }
                  }}
                  onDataChange={(val, setFieldValue) => {
                    setFieldValue(
                      `vehicleRegNo.part3`,
                      val?.toString()?.toUpperCase(),
                    );
                    setFieldValue(`isRegNoVerified`, null);
                    setFieldValue(`isMakeDeclined`, null);
                    setFieldValue(`isZoopServiceCalled`, null);
                  }}
                />
                <span
                  className={`flex items-center font-bold 
                  ${(values?.quotationNo !== '' && !modify)||
                    loadingVehicleDetials ||
                    loadingBusinessType
                    ? 'bg-neutral-light'
                    : ''
                    } h-12`}
                >
                  -
                </span>
                <QuantaInput
                  name="vehicleRegNo.part4"
                  maxLength="2"
                  size="full"
                  type="text"
                  placeholder="AA"
                  className="uppercase"
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType || 
                    (values?.quotationNo !== '' && !modify)
                  }
                  onDataChange={(val, setFieldValue) => {
                    setFieldValue(
                      `vehicleRegNo.part4`,
                      val?.toString()?.toUpperCase(),
                    );
                    setFieldValue(`isRegNoVerified`, null);
                    setFieldValue(`isRegNoVerified`, null)
                    setFieldValue(`isZoopServiceCalled`, null);
                  }}
                  onKeyDown={({ key }) => {
                    const { vehicleRegNo } = values;
                    const { part1, part2, part3, part4 } =
                      vehicleRegNo;
                    if (
                      key === 'Enter' &&
                      (validate(values)?.regNo ===
                        '* Click the search icon to fetch the Vehicle Details' ||
                        !validate(values)?.regNo) &&
                      part1?.length === 2 &&
                      part2?.length === 2 &&
                      part3?.length === 4 &&
                      part4?.length === 2
                    ) {
                      onFLALookup({ values, setFieldValue });
                    }
                  }}
                  noerror
                />
                <QuantaButton
                  type="button"
                  className="w-32"
                  disabled={
                    loadingVehicleDetials ||
                    loadingBusinessType || 
                    (values?.quotationNo !== '' && !modify)
                  }
                  onClick={async ({
                    values,
                    isValid,
                    setFieldValue,
                  }) => {
                    onFLALookup({ values, setFieldValue });
                  }}
                >
                  {!loadingVehicleDetials && (
                    <FontAwesomeIcon icon={faSearch} />
                  )}
                  {loadingVehicleDetials && (
                    <FontAwesomeIcon icon={faSpinner} spin={true} />
                  )}
                </QuantaButton>
              </>
            ),
            label: (
              <>
                Enter Registration Number to find your Vehicle
                <Text></Text>
              </>
            ),
            name: 'regNo',
            // colSpan: repeat,
          },
          {
            type: 'checkbox',
            name: 'vehicleRegNo.bhseries',
            disabled: (values?.quotationNo !== '' && !modify),
            label: 'BH Registration Number',
            onDataChange: async (val, setFieldValue) => {
            //  if (val!==true)
            //  {
              setFieldValue('vehicleRegNo.part4','')
              setFieldValue('vehicleRegNo.part3','')
              setFieldValue('vehicleRegNo.part2','')
              setFieldValue('vehicleRegNo.part1','')
             //}
            }
          },
          {
            type: 'render',
            colSpan:
              repeat === repeat_for_mobile ? repeat_for_mobile : 2,
            component: () => (
              <Text
                className={
                  repeat === repeat_for_mobile
                    ? 'flex items-baseline -mt-2'
                    : 'flex mt-8 items-center'
                }
              >
                {errorFLADetails ? (
                  <Text className={`flex gap-2 justify-start w-full`}>
                    <Text severity={'error'}>
                      <FontAwesomeIcon icon={faExclamation} />
                    </Text>
                    <Text severity="error">
                    {errorFLADetails}
                    </Text>
                  </Text>
                ) : values?.isRegNoVerified === false && (
                  <Text className={`flex gap-2 justify-start w-full`}>
                    <Text severity={'error'}>
                      <FontAwesomeIcon icon={faExclamation} />
                    </Text>
                    <Text severity="error">
                      We couldn't find any vehicle for input
                      registration number, please enter manually
                    </Text>
                  </Text>
                )}
                {values?.isRegNoVerified && (
                  <Text
                    className={`flex gap-2 justify-start w-full ${repeat === repeat_for_mobile ? 'my-1' : ''
                      }`}
                  >
                    <Text severity={'success'}>
                      <FontAwesomeIcon icon={faCheck} />
                    </Text>
                    <Text>
                      We have found below Vehicle details for your
                      input registration number
                    </Text>
                  </Text>
                )}
              </Text>
            ),
          },
          (!values?.quotationNo || modify )
            ? {
              type: 'render',
              // disabled: true,
              colSpan: repeat,
              component: () =>
                repeat === repeat_for_desktop ? (
                  <div className="flex flex-row space-x-1 mb-1">
                    <Text>
                      Don't have registration number or manually
                      enter vehicle details?
                    </Text>
                    {(values?.quotationNo === '' || modify) && (
                      <Text
                        className="quanta_link"
                        onClick={(_) => {
                          setShowVehicleDetailsModal(true);
                          if(!values?.isZoopServiceCalled){
                            setFieldValue(`policyExpiryDate`, '',);
                            setFieldValue(`policyStartDate`, '',);
                            setFieldValue(`policyCoverType`, '',);
                            setFieldValue(`policyTenure`, '',);
                            setFieldValue(`policyTenureValue`, '',);
                            setFieldValue(`prevInsurance`, {
                              insurerName: '',
                              policyNumber: '',
                              expiryDate: '',
                              startDate: '',
                              coverType: '',
                              policyTenure: '',
                            });
                          }
                        }
                        }
                      >
                        Click Here
                      </Text>
                    )}
                  </div>
                ) : (
                  <div className="flex flex-row space-x-1 mb-1">
                    <Text>
                      Don't have registration number or manually
                      enter vehicle details?{' '}
                      <Text
                        className="quanta_link"
                        onClick={(_) => {
                          setShowVehicleDetailsModal(true);
                          if(!values?.isZoopServiceCalled){
                            setFieldValue(`policyExpiryDate`, '',);
                            setFieldValue(`policyStartDate`, '',);
                            setFieldValue(`policyCoverType`, '',);
                            setFieldValue(`policyTenure`, '',);
                            setFieldValue(`policyTenureValue`, '',);
                            setFieldValue(`prevInsurance`, {
                              insurerName: '',
                              policyNumber: '',
                              expiryDate: '',
                              startDate: '',
                              coverType: '',
                              policyTenure: '',
                            });
                          }
                        }
                        }
                      >
                        Click Here
                      </Text>
                    </Text>
                  </div>
                ),
            }
            : null,
          vehicleDetailValues || values?.make?.code
            ? {
              type: 'render',
              colSpan: repeat,
              component: () => (
                <VehicleDetails
                  vehicleDetailValues={vehicleDetailValues}
                  {...{
                    lobCode,
                    lobName,
                    productCode1,
                    productName,
                    quoteNumber,
                    businessType
                  }}
                />
              ),
            }
            : null,
        ].filter((d) => d),
      },
      values?.businessType 
      //&& values?.businessType?.trim()?.toLowerCase() === 'roll over' || values?.businessType?.toLowerCase() === 'used car'
       ?
         {
          title: 'Previous Insurance & Claims',
          grid_data: [
            productCode1?.toString()?.toLowerCase() === '3151' ?
            {
              type: 'radiogroup',
              label: values?.businessType?.toString()?.toLowerCase() ==='used car' ? (
                <>
                  Was there any policy previously taken for the
                  vehicle?
                </>
              ) : (
                <>
                  Was there any policy previously taken for the
                  vehicle?<Text severity="error"> *</Text>
                </>
              ),
              colSpan: repeat,
              name: 'anyPreviousPolicyforVehicleTaken',
              disabledGlobal:
              (values?.quotationNo !== '' && !modify) ||
              values?.businessTypeValue?.toLowerCase() ===
                'used car' || values?.businessType?.toString()?.toLowerCase() ==='used car',
              data: [
                {
                  label: 'Yes',
                  value: 'Yes',
                }
                ],
                onDataChange: (val, setFieldValue) => {
                  setFieldValue(
                    `anyPreviousPolicyforVehicleTaken`,
                    val,
                  );
                  if (val?.toString?.toLowerCase() === 'no') {
                    setFieldValue(`policyCoverType`, '');
                    setFieldValue(`policyTenure`, '');
                    setFieldValue(`policyTenureValue`, '');
                    setFieldValue(`policyStartDate`, '');
                    setFieldValue(`policyExpiryDate`, '');
                    setFieldValue(`totalClaimCount`, '');
                    setFieldValue(`totalClaimCountValue`, '');
                    setFieldValue(`noOfClaimsOneYear`, '');
                    setFieldValue(`noOfClaimsTwoYears`, '');
                    setFieldValue(`noOfClaimsThreeYears`, '');
                    setFieldValue(`totalClaimAmount`, '');
                    setFieldValue(`previousYearNCBSlab`, '');
                  }
                },
              } :
              {
                type: 'radiogroup',
                label: values?.businessType?.toString()?.toLowerCase() === 'used car' ? (
                  <>
                    Was there any policy previously taken for the
                    vehicle?
                  </>
                ) : (
                  <>
                    Was there any policy previously taken for the
                    vehicle?<Text severity="error"> *</Text>
                  </>
                ),
                colSpan: repeat,
                name: 'anyPreviousPolicyforVehicleTaken',
                disabledGlobal:
                  (values?.quotationNo !== '' && !modify) ||
              values?.businessTypeValue?.toLowerCase() ===
                'used car' || values?.businessType?.toString()?.toLowerCase() ==='used car',
              data: [
                {
                  label: 'Yes',
                  value: 'Yes',
                },
                {
                  label: 'No',
                  value: 'No',
                },
              ],
              onDataChange : (val,setFieldValue) =>{
                setFieldValue(
                  `anyPreviousPolicyforVehicleTaken`,
                  val,
                );
                if(val?.toString?.toLowerCase() === 'no'){
                  setFieldValue(`policyCoverType`, '');
                  setFieldValue(`policyTenure`, '');
                  setFieldValue(`policyTenureValue`, '');
                  setFieldValue(`policyStartDate`, '');
                  setFieldValue(`policyExpiryDate`, '');
                  setFieldValue(`totalClaimCount`, '');
                  setFieldValue(`totalClaimCountValue`, '');
                  setFieldValue(`noOfClaimsOneYear`, '');
                  setFieldValue(`noOfClaimsTwoYears`, '');
                  setFieldValue(`noOfClaimsThreeYears`, '');
                  setFieldValue(`totalClaimAmount`, '');
                  setFieldValue(`previousYearNCBSlab`, '');
                }
              },
            },
            (values?.anyPreviousPolicyforVehicleTaken === 'Yes' 
               || values?.businessType?.toString()?.toLowerCase() ==='used car'
            )   ? {
                type: 'render',
                colSpan: repeat,
                component: () => (
                  <PreviousInsurance
                    productCode={productCode1}
                    productName={productName}
                    lobCode={lobCode}
                    lobName={lobName}
                    quoteNumber={quoteNumber}
                    setPolicyTermList={setPolicyTermList}
                    modify={modify}
                  />
                ),
              }
              : null,
            (values?.anyPreviousPolicyforVehicleTaken === 'Yes' || values?.businessType?.toString()?.toLowerCase() ===
            'used car')
              //  &&
              //   values?.policyTenure
              ? {
                type: 'render',
                colSpan: repeat,
                component: () => (
                  <PreviousClaims
                    productCode={productCode1}
                    productName={productName}
                    lobCode={lobCode}
                    lobName={lobName}
                    quoteNumber={quoteNumber}
                    policyTenure={
                      policyTermList &&
                        policyTermList?.PRD_PreviousPolicyTermList
                        ? getDomainData(
                          policyTermList?.PRD_PreviousPolicyTermList,
                          values?.policyTenure,
                          'code',
                          'value',
                        )
                        : ''
                    }
                    policyTerm={values?.policyTerm}
                    branding={branding}
                    modify={modify}
                  />
                ),
              }
              : null,
          ].filter((d) => d),
        }
        : null,
        productCode1.toString() === '3151' && values?.anyPreviousPolicyforVehicleTaken === 'Yes' 
        // &&  values?.policyCoverType!=='OD Only'
        ?
        {
          title: 'TP Policy details',
          grid_data: [
              {
                type: 'render',
                colSpan: repeat === repeatForDesktop ? 1 : repeat,
                component: () => (
                  <div className="flex flex-col space-y-2 w-full">
                    <Grid
                      flow="cols"
                      repeat={repeat === repeatForDesktop ? 1 : repeat}
                      gap={4}
                      className="w-full"
                    >
                      <GridItem
                        colSpan={repeat === repeatForDesktop ? 1 : repeat}
                        className="px-3"
                      >
                        <QuantaDateInput
                          size={'full'}
                          label={
                              <Text type="label">
                               End Date
                                          <Text severity="error"> *</Text>
                              </Text>
                          }
                          name={'TP_End_Date'}
                          calendarPosition={'top'}

                          onDataChange={ async (val, setFieldValue) => {
                            setFieldValue(
                              `TP_Start_Date`,
                              moment(val,"DD/MM/YYYY").add(1,'days')
                              .subtract(3, 'years')
                              .format('DD/MM/YYYY')
                              );
                        }}
                          scrollStopWhenCalendarOpen={false}
                        />
                      </GridItem>
                    </Grid>
                  </div>
                ),
              },
              {
                type: 'render',
                colSpan: repeat === repeatForDesktop ? 1 : repeat,
                component: () => (
                  <div className="flex flex-col space-y-2 w-full">
                    <Grid
                      flow="cols"
                      repeat={repeat === repeatForDesktop ? 1 : repeat}
                      gap={4}
                      className="w-full"
                    >
                      <GridItem
                        colSpan={repeat === repeatForDesktop ? 1 : repeat}
                        className="px-3"
                      >
                        <QuantaDateInput
                          size={'full'}
                          label={
                              <Text type="label">
                              Start Date
                                          <Text severity="error"> *</Text>
                              </Text>
                          }
                          name={'TP_Start_Date'}
                          calendarPosition={'top'}
                               
                          scrollStopWhenCalendarOpen={false}
                        />
                      </GridItem>
                    </Grid>
                  </div>
                ),
              },
          ]
        }:null,
      //   productCode1?.toString() !== '3176'
      //  ? {
      //   title: 'Insured Declared Value',
      //   grid_data: [
      //     {
      //       type: 'render',
      //       colSpan: repeat,
      //       component: () => (
      //         <InsuredDeclaredForm
      //           productCode={productCode1}
      //           productName={productName}
      //           lobCode={lobCode}
      //           lobName={lobName}
      //           quoteNumber={quoteNumber}
      //           makeCode={values?.make?.code}
      //           varientCode={values?.variant?.code}
      //           rtoCode={values?.rtoLocationCode}
      //           setFieldValue={setFieldValue}
      //           branding={branding}
      //           dateOfReg={values?.dateOfReg}//SAIDVissue
      //           modify={modify}//SAMOD
      //           pastPolicyExpiryDate={values?.policyExpiryDate}
      //           anyPreviousPolicyforVehicleTaken={values?.anyPreviousPolicyforVehicleTaken}
      //           businessType={values?.businessTypeValue
      //           || values?.businessType}
      //         />
      //       ),
      //     },
      //   ],
      //    } : null,
      // {
      //   // title: 'Add-On-Covers',
      //   grid_data: [
      //     {
      //       type: 'render',
      //       colSpan: repeat,
      //       component: () => (
      //         <>
      //           <CoversForm
      //             tenureList={coversInfo?.applicableCovers?.tenure}
      //             riskCovers={coversInfo?.applicableCovers?.riskCovers}
      //             productCode={productCode1}
      //             productName={productName}
      //             lobCode={lobCode}
      //             lobName={lobName}
      //             quoteNumber={quoteNumber}
      //             motorQuote={motorQuote}
      //             selectedIntermediary={selectedIntermediary}
      //             fieldUserList={fieldUserList}
      //             setFieldValue={setFieldValue}
      //             characterLimitList={characterLimitList}
      //             vehicleDetailValues = {vehicleDetailValues}
      //             consumable_limit={consumable_limit}
      //             DEP_limit={consumable_limit}
      //             NCB_limit={NCB_limit}
      //             DCA_limit={DCA_limit}
      //             TENYR_LIMIT={TENYR_LIMIT}
      //             forwardedCoversFormRef={props?.forwardedCoversFormRef}
      //             modify={modify}
      //           />
      //         </>
      //       ),
      //     },
      //   ].filter((d) => d),
      // },
      {
        title: 'Other Discounts',
        grid_data: [
          {
            type: 'render',
            colSpan: repeat,
            component: () => (
              <>
                <Discounts
                  branding={branding}
                  {...{
                    lobCode,
                   productCode: productCode1,
                    productName,
                    lobName,
                    quoteNumber,
                    modify,
                    // renderExpandedCards
                  }}
                />
                {/* {productCode1?.toString() !== '3176'
                && (
                <IRFForm
                  productCode={productCode1}
                  productName={productName}
                  lobCode={lobCode}
                  lobName={lobName}
                  quoteNumber={quoteNumber}
                  makeCode={values?.make?.code}
                  varientCode={values?.variant?.code}
                  rtoCode={values?.rtoLocationCode}
                  setFieldValue={setFieldValue}
                  branding={branding}
                  dateOfReg={values?.dateOfReg}//SAIDVissue
                  modify={modify}
                  pastPolicyExpiryDate={values?.policyExpiryDate}
                  anyPreviousPolicyforVehicleTaken={values?.anyPreviousPolicyforVehicleTaken}
                  businessType={values?.businessTypeValue
                  || values?.businessType}
                />
                )} */}
              </>
            ),
          },
        ].filter((d) => d),
      },

    ].filter((d) => d);


    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      // useExpandablePaper:true
    };


    // const other_props1 = {
    //   flow: 'cols',
    //   repeat,
    //   gapX: 6,
    //   gapY: 0,
    //   spaceY: 2,
    //   size: 'full',
    //   titleSeverity: 'info',
    //   useExpandablePaper:true
    // };
    // const data1 = [
    //   {
    //      title: 'Additional Details',
    //     grid_data: [
    //       {
    //         type: 'render',
    //         colSpan: repeat,
    //         component: () => (
    //           <Discounts
    //             branding={branding}
    //             {...{
    //               lobCode,
    //               productCode,
    //               productName,
    //               lobName,
    //               quoteNumber,
    //               // renderExpandedCards
    //             }}
    //           />
    //         ),
    //       },
    //     ].filter((d) => d),
    //   },
    // ].filter((d) => d);

    return (
      <div>
        <QuantaForm className="space-y-4">
          <MixedGridGroup {...{ data, ...other_props }} />
        </QuantaForm>
        {/* <MixedGridGroup {...{ data:data1, ...other_props1 }} /> */}
        <VehicleDataModal
          vehicleRegNo={`${values?.vehicleRegNo?.part1}${values?.vehicleRegNo?.part2}${values?.vehicleRegNo?.part3}${values?.vehicleRegNo?.part4}`}
          engineNo={values?.engineNo}
          chasisNo={values?.chasisNo}
          setParentFieldValue={setFieldValue}
          {...{
            setShowVehicleDetailsModal,
            showVehicleDetailsModal,
            setVehicleDetailValues: setVehicleDetailValues,
            vehicleDtls:vehicleDtls,
            businessType,
            productCode:productCode1,
            productName,
            lobCode,
            lobName,
            quoteNumber,
            submitForm,
            pastPolicyExpiryDate:values?.expiryDate,
            anyPreviousPolicyforVehicleTaken:values?.anyPreviousPolicyforVehicleTaken,
          }}
        />
      </div>
    );
  };
  return (
    <>
      <div>
        {!initialValues && (
          <div className="min-h-screen">
            <Loading />
          </div>
        )}
        {initialValues && (
          <QuantaFormik
            innerRef={props?.forwardedRef}
            enableReinitialize={true}
            {...{
              initialValues,
              validate,
              onSubmit,
            }}
          >
            <VehicleForm {...{ validate, coversInfo }} />
          </QuantaFormik>
        )}
      </div>
    </>
  );
}
